// source: entity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.proto.Entity', null, global);
goog.exportSymbol('proto.proto.Entity.AccountData', null, global);
goog.exportSymbol('proto.proto.Entity.AccountInfo', null, global);
goog.exportSymbol('proto.proto.Entity.AgoraConfigInfo', null, global);
goog.exportSymbol('proto.proto.Entity.AttachmentInfo', null, global);
goog.exportSymbol('proto.proto.Entity.AttachmentList', null, global);
goog.exportSymbol('proto.proto.Entity.AuthorizationAppInfo', null, global);
goog.exportSymbol('proto.proto.Entity.AuthorizationInfoData', null, global);
goog.exportSymbol('proto.proto.Entity.BandConfigInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ChannelCooperationInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ChannelInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ChannelList', null, global);
goog.exportSymbol('proto.proto.Entity.ChannelMsgInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ChannelMsgRelayNty', null, global);
goog.exportSymbol('proto.proto.Entity.ChannelMsgSendReq', null, global);
goog.exportSymbol('proto.proto.Entity.ChannelUserData', null, global);
goog.exportSymbol('proto.proto.Entity.ChannelUserStateInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ChatMsgData', null, global);
goog.exportSymbol('proto.proto.Entity.ChatMsgInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ConferenceCorpInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ConferenceDetailInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ConferenceJoinResponseInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ConferenceMemberInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ConferenceMemberRole', null, global);
goog.exportSymbol('proto.proto.Entity.ConferenceModifyParam', null, global);
goog.exportSymbol('proto.proto.Entity.ConferenceQueryResultInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ConferenceRoleRequestNty', null, global);
goog.exportSymbol('proto.proto.Entity.ConferenceRoleRequestReply', null, global);
goog.exportSymbol('proto.proto.Entity.ConferenceSummaryInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ConferenceUpdateNty', null, global);
goog.exportSymbol('proto.proto.Entity.ConferenceUpdateNtyList', null, global);
goog.exportSymbol('proto.proto.Entity.ConfigInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ContactBaseData', null, global);
goog.exportSymbol('proto.proto.Entity.ContactBaseInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ContactInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ContactMatchResult', null, global);
goog.exportSymbol('proto.proto.Entity.CooperationType', null, global);
goog.exportSymbol('proto.proto.Entity.CorpData', null, global);
goog.exportSymbol('proto.proto.Entity.CorpInfo', null, global);
goog.exportSymbol('proto.proto.Entity.CorpOrganizationInfo', null, global);
goog.exportSymbol('proto.proto.Entity.CorpOrganizationNode', null, global);
goog.exportSymbol('proto.proto.Entity.DownloadRspInfo', null, global);
goog.exportSymbol('proto.proto.Entity.EnableLiveStreamData', null, global);
goog.exportSymbol('proto.proto.Entity.Error', null, global);
goog.exportSymbol('proto.proto.Entity.ExternalContactInfo', null, global);
goog.exportSymbol('proto.proto.Entity.GroupInfo', null, global);
goog.exportSymbol('proto.proto.Entity.GroupList', null, global);
goog.exportSymbol('proto.proto.Entity.GroupMemberInfo', null, global);
goog.exportSymbol('proto.proto.Entity.HisRtcConfigInfo', null, global);
goog.exportSymbol('proto.proto.Entity.IMServerConfig', null, global);
goog.exportSymbol('proto.proto.Entity.InviteDynamicData', null, global);
goog.exportSymbol('proto.proto.Entity.InviteDynamicDetailInfo', null, global);
goog.exportSymbol('proto.proto.Entity.InviteInfo', null, global);
goog.exportSymbol('proto.proto.Entity.InviteNotifyInfo', null, global);
goog.exportSymbol('proto.proto.Entity.LatestVersionInfo', null, global);
goog.exportSymbol('proto.proto.Entity.LeiaRtcConfigInfo', null, global);
goog.exportSymbol('proto.proto.Entity.LiveStreamCtrlInfo', null, global);
goog.exportSymbol('proto.proto.Entity.LiveStreamResponse', null, global);
goog.exportSymbol('proto.proto.Entity.LiveStreamUrlResponse', null, global);
goog.exportSymbol('proto.proto.Entity.MatchContactBaseData', null, global);
goog.exportSymbol('proto.proto.Entity.MatchContactBaseInfoItem', null, global);
goog.exportSymbol('proto.proto.Entity.MediaEngineConfigInfo', null, global);
goog.exportSymbol('proto.proto.Entity.MqttConfigInfo', null, global);
goog.exportSymbol('proto.proto.Entity.OrganizationStreamInfo', null, global);
goog.exportSymbol('proto.proto.Entity.PushNewMessage', null, global);
goog.exportSymbol('proto.proto.Entity.PushNotify', null, global);
goog.exportSymbol('proto.proto.Entity.PushSignalingInviteNty', null, global);
goog.exportSymbol('proto.proto.Entity.QueryConferenceCondition', null, global);
goog.exportSymbol('proto.proto.Entity.RecentContactInfo', null, global);
goog.exportSymbol('proto.proto.Entity.RecentContactList', null, global);
goog.exportSymbol('proto.proto.Entity.RecentCorpList', null, global);
goog.exportSymbol('proto.proto.Entity.ServerConfigInfo', null, global);
goog.exportSymbol('proto.proto.Entity.SessionStateInfo', null, global);
goog.exportSymbol('proto.proto.Entity.SessionUserStateInfo', null, global);
goog.exportSymbol('proto.proto.Entity.ShareInfo', null, global);
goog.exportSymbol('proto.proto.Entity.SubOrganizationInfo', null, global);
goog.exportSymbol('proto.proto.Entity.SubOrganizationNode', null, global);
goog.exportSymbol('proto.proto.Entity.SyncCCtrlReq', null, global);
goog.exportSymbol('proto.proto.Entity.TagInfo', null, global);
goog.exportSymbol('proto.proto.Entity.TagList', null, global);
goog.exportSymbol('proto.proto.Entity.ToolkitConfigInfo', null, global);
goog.exportSymbol('proto.proto.Entity.UniqueErrorInfo', null, global);
goog.exportSymbol('proto.proto.Entity.UploadRspInfo', null, global);
goog.exportSymbol('proto.proto.Entity.UserInfo', null, global);
goog.exportSymbol('proto.proto.Entity.UserStatusData', null, global);
goog.exportSymbol('proto.proto.Entity.UserStatusInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.displayName = 'proto.proto.Entity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.BandConfigInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.BandConfigInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.BandConfigInfo.displayName = 'proto.proto.Entity.BandConfigInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ServerConfigInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ServerConfigInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ServerConfigInfo.displayName = 'proto.proto.Entity.ServerConfigInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.AccountInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.AccountInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.AccountInfo.displayName = 'proto.proto.Entity.AccountInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.AccountData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.AccountData.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.AccountData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.AccountData.displayName = 'proto.proto.Entity.AccountData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.UserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.UserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.UserInfo.displayName = 'proto.proto.Entity.UserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ContactInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ContactInfo.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ContactInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ContactInfo.displayName = 'proto.proto.Entity.ContactInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.UserStatusInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.UserStatusInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.UserStatusInfo.displayName = 'proto.proto.Entity.UserStatusInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.UserStatusData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.UserStatusData.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.UserStatusData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.UserStatusData.displayName = 'proto.proto.Entity.UserStatusData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.MqttConfigInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.MqttConfigInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.MqttConfigInfo.displayName = 'proto.proto.Entity.MqttConfigInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.AgoraConfigInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.AgoraConfigInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.AgoraConfigInfo.displayName = 'proto.proto.Entity.AgoraConfigInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.HisRtcConfigInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.HisRtcConfigInfo.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.HisRtcConfigInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.HisRtcConfigInfo.displayName = 'proto.proto.Entity.HisRtcConfigInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.LeiaRtcConfigInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.LeiaRtcConfigInfo.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.LeiaRtcConfigInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.LeiaRtcConfigInfo.displayName = 'proto.proto.Entity.LeiaRtcConfigInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.IMServerConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.IMServerConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.IMServerConfig.displayName = 'proto.proto.Entity.IMServerConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ToolkitConfigInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ToolkitConfigInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ToolkitConfigInfo.displayName = 'proto.proto.Entity.ToolkitConfigInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConfigInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ConfigInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConfigInfo.displayName = 'proto.proto.Entity.ConfigInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.MediaEngineConfigInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.MediaEngineConfigInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.MediaEngineConfigInfo.displayName = 'proto.proto.Entity.MediaEngineConfigInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.LatestVersionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.LatestVersionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.LatestVersionInfo.displayName = 'proto.proto.Entity.LatestVersionInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.SessionStateInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.SessionStateInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.SessionStateInfo.displayName = 'proto.proto.Entity.SessionStateInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ChannelUserStateInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ChannelUserStateInfo.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ChannelUserStateInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ChannelUserStateInfo.displayName = 'proto.proto.Entity.ChannelUserStateInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.SessionUserStateInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.SessionUserStateInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.SessionUserStateInfo.displayName = 'proto.proto.Entity.SessionUserStateInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ChannelUserData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ChannelUserData.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ChannelUserData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ChannelUserData.displayName = 'proto.proto.Entity.ChannelUserData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.LiveStreamUrlResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.LiveStreamUrlResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.LiveStreamUrlResponse.displayName = 'proto.proto.Entity.LiveStreamUrlResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.LiveStreamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.LiveStreamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.LiveStreamResponse.displayName = 'proto.proto.Entity.LiveStreamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.LiveStreamCtrlInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.LiveStreamCtrlInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.LiveStreamCtrlInfo.displayName = 'proto.proto.Entity.LiveStreamCtrlInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.EnableLiveStreamData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.EnableLiveStreamData.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.EnableLiveStreamData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.EnableLiveStreamData.displayName = 'proto.proto.Entity.EnableLiveStreamData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.Error = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.Error, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.Error.displayName = 'proto.proto.Entity.Error';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ChatMsgInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ChatMsgInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ChatMsgInfo.displayName = 'proto.proto.Entity.ChatMsgInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ChannelMsgInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ChannelMsgInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ChannelMsgInfo.displayName = 'proto.proto.Entity.ChannelMsgInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ChatMsgData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ChatMsgData.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ChatMsgData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ChatMsgData.displayName = 'proto.proto.Entity.ChatMsgData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.GroupMemberInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.GroupMemberInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.GroupMemberInfo.displayName = 'proto.proto.Entity.GroupMemberInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.GroupInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.GroupInfo.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.GroupInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.GroupInfo.displayName = 'proto.proto.Entity.GroupInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.GroupList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.GroupList.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.GroupList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.GroupList.displayName = 'proto.proto.Entity.GroupList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.RecentContactInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.RecentContactInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.RecentContactInfo.displayName = 'proto.proto.Entity.RecentContactInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.RecentContactList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.RecentContactList.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.RecentContactList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.RecentContactList.displayName = 'proto.proto.Entity.RecentContactList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ChannelCooperationInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ChannelCooperationInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ChannelCooperationInfo.displayName = 'proto.proto.Entity.ChannelCooperationInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ChannelMsgSendReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ChannelMsgSendReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ChannelMsgSendReq.displayName = 'proto.proto.Entity.ChannelMsgSendReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ChannelMsgRelayNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ChannelMsgRelayNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ChannelMsgRelayNty.displayName = 'proto.proto.Entity.ChannelMsgRelayNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.SyncCCtrlReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.SyncCCtrlReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.SyncCCtrlReq.displayName = 'proto.proto.Entity.SyncCCtrlReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.OrganizationStreamInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.OrganizationStreamInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.OrganizationStreamInfo.displayName = 'proto.proto.Entity.OrganizationStreamInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ChannelInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ChannelInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ChannelInfo.displayName = 'proto.proto.Entity.ChannelInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ChannelList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ChannelList.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ChannelList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ChannelList.displayName = 'proto.proto.Entity.ChannelList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ContactBaseData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ContactBaseData.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ContactBaseData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ContactBaseData.displayName = 'proto.proto.Entity.ContactBaseData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ContactBaseInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ContactBaseInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ContactBaseInfo.displayName = 'proto.proto.Entity.ContactBaseInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.SubOrganizationInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.SubOrganizationInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.SubOrganizationInfo.displayName = 'proto.proto.Entity.SubOrganizationInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.SubOrganizationNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.SubOrganizationNode.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.SubOrganizationNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.SubOrganizationNode.displayName = 'proto.proto.Entity.SubOrganizationNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.CorpOrganizationNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.CorpOrganizationNode.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.CorpOrganizationNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.CorpOrganizationNode.displayName = 'proto.proto.Entity.CorpOrganizationNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.CorpOrganizationInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.CorpOrganizationInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.CorpOrganizationInfo.displayName = 'proto.proto.Entity.CorpOrganizationInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.InviteDynamicData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.InviteDynamicData.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.InviteDynamicData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.InviteDynamicData.displayName = 'proto.proto.Entity.InviteDynamicData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.InviteInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.InviteInfo.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.InviteInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.InviteInfo.displayName = 'proto.proto.Entity.InviteInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ShareInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ShareInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ShareInfo.displayName = 'proto.proto.Entity.ShareInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.InviteDynamicDetailInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.InviteDynamicDetailInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.InviteDynamicDetailInfo.displayName = 'proto.proto.Entity.InviteDynamicDetailInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ExternalContactInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ExternalContactInfo.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ExternalContactInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ExternalContactInfo.displayName = 'proto.proto.Entity.ExternalContactInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.CorpData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.CorpData.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.CorpData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.CorpData.displayName = 'proto.proto.Entity.CorpData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.CorpInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.CorpInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.CorpInfo.displayName = 'proto.proto.Entity.CorpInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.RecentCorpList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.RecentCorpList.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.RecentCorpList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.RecentCorpList.displayName = 'proto.proto.Entity.RecentCorpList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.InviteNotifyInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.InviteNotifyInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.InviteNotifyInfo.displayName = 'proto.proto.Entity.InviteNotifyInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.TagList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.TagList.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.TagList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.TagList.displayName = 'proto.proto.Entity.TagList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.TagInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.TagInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.TagInfo.displayName = 'proto.proto.Entity.TagInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.AttachmentList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.AttachmentList.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.AttachmentList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.AttachmentList.displayName = 'proto.proto.Entity.AttachmentList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.AttachmentInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.AttachmentInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.AttachmentInfo.displayName = 'proto.proto.Entity.AttachmentInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConferenceMemberInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ConferenceMemberInfo.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ConferenceMemberInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConferenceMemberInfo.displayName = 'proto.proto.Entity.ConferenceMemberInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConferenceDetailInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ConferenceDetailInfo.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ConferenceDetailInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConferenceDetailInfo.displayName = 'proto.proto.Entity.ConferenceDetailInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.QueryConferenceCondition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.QueryConferenceCondition.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.QueryConferenceCondition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.QueryConferenceCondition.displayName = 'proto.proto.Entity.QueryConferenceCondition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConferenceMemberRole = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ConferenceMemberRole.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ConferenceMemberRole, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConferenceMemberRole.displayName = 'proto.proto.Entity.ConferenceMemberRole';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConferenceSummaryInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ConferenceSummaryInfo.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ConferenceSummaryInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConferenceSummaryInfo.displayName = 'proto.proto.Entity.ConferenceSummaryInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConferenceCorpInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ConferenceCorpInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConferenceCorpInfo.displayName = 'proto.proto.Entity.ConferenceCorpInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConferenceQueryResultInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ConferenceQueryResultInfo.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ConferenceQueryResultInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConferenceQueryResultInfo.displayName = 'proto.proto.Entity.ConferenceQueryResultInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConferenceJoinResponseInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ConferenceJoinResponseInfo.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ConferenceJoinResponseInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConferenceJoinResponseInfo.displayName = 'proto.proto.Entity.ConferenceJoinResponseInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConferenceRoleRequestNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ConferenceRoleRequestNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConferenceRoleRequestNty.displayName = 'proto.proto.Entity.ConferenceRoleRequestNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConferenceRoleRequestReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ConferenceRoleRequestReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConferenceRoleRequestReply.displayName = 'proto.proto.Entity.ConferenceRoleRequestReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConferenceUpdateNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ConferenceUpdateNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConferenceUpdateNty.displayName = 'proto.proto.Entity.ConferenceUpdateNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConferenceUpdateNtyList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ConferenceUpdateNtyList.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ConferenceUpdateNtyList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConferenceUpdateNtyList.displayName = 'proto.proto.Entity.ConferenceUpdateNtyList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ConferenceModifyParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.ConferenceModifyParam.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.ConferenceModifyParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ConferenceModifyParam.displayName = 'proto.proto.Entity.ConferenceModifyParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.UploadRspInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.UploadRspInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.UploadRspInfo.displayName = 'proto.proto.Entity.UploadRspInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.DownloadRspInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.DownloadRspInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.DownloadRspInfo.displayName = 'proto.proto.Entity.DownloadRspInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.UniqueErrorInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.UniqueErrorInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.UniqueErrorInfo.displayName = 'proto.proto.Entity.UniqueErrorInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.PushNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.PushNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.PushNotify.displayName = 'proto.proto.Entity.PushNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.PushNewMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.PushNewMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.PushNewMessage.displayName = 'proto.proto.Entity.PushNewMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.PushSignalingInviteNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.PushSignalingInviteNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.PushSignalingInviteNty.displayName = 'proto.proto.Entity.PushSignalingInviteNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.ContactMatchResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.ContactMatchResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.ContactMatchResult.displayName = 'proto.proto.Entity.ContactMatchResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.MatchContactBaseInfoItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.MatchContactBaseInfoItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.MatchContactBaseInfoItem.displayName = 'proto.proto.Entity.MatchContactBaseInfoItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.MatchContactBaseData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.MatchContactBaseData.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.MatchContactBaseData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.MatchContactBaseData.displayName = 'proto.proto.Entity.MatchContactBaseData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.AuthorizationAppInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Entity.AuthorizationAppInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.AuthorizationAppInfo.displayName = 'proto.proto.Entity.AuthorizationAppInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Entity.AuthorizationInfoData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.Entity.AuthorizationInfoData.repeatedFields_, null);
};
goog.inherits(proto.proto.Entity.AuthorizationInfoData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Entity.AuthorizationInfoData.displayName = 'proto.proto.Entity.AuthorizationInfoData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity}
 */
proto.proto.Entity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity;
  return proto.proto.Entity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity}
 */
proto.proto.Entity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.proto.Entity.CooperationType = {
  NORMAL: 0,
  WHITEBOARD: 1,
  REALTIMEANNOTATION: 2,
  FREEZE: 3,
  SLAMANNOTATION: 4,
  SCREENSHARE: 5
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.BandConfigInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.BandConfigInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.BandConfigInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.BandConfigInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    corpid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    appname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    windowslogo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ioslogo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    androidlogo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    glasseslogo: jspb.Message.getFieldWithDefault(msg, 6, ""),
    enableaboutinfo: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.BandConfigInfo}
 */
proto.proto.Entity.BandConfigInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.BandConfigInfo;
  return proto.proto.Entity.BandConfigInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.BandConfigInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.BandConfigInfo}
 */
proto.proto.Entity.BandConfigInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWindowslogo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIoslogo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAndroidlogo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setGlasseslogo(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableaboutinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.BandConfigInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.BandConfigInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.BandConfigInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.BandConfigInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWindowslogo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIoslogo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAndroidlogo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getGlasseslogo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEnableaboutinfo();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string corpID = 1;
 * @return {string}
 */
proto.proto.Entity.BandConfigInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.BandConfigInfo} returns this
 */
proto.proto.Entity.BandConfigInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string appName = 2;
 * @return {string}
 */
proto.proto.Entity.BandConfigInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.BandConfigInfo} returns this
 */
proto.proto.Entity.BandConfigInfo.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string windowsLogo = 3;
 * @return {string}
 */
proto.proto.Entity.BandConfigInfo.prototype.getWindowslogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.BandConfigInfo} returns this
 */
proto.proto.Entity.BandConfigInfo.prototype.setWindowslogo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string iOSLogo = 4;
 * @return {string}
 */
proto.proto.Entity.BandConfigInfo.prototype.getIoslogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.BandConfigInfo} returns this
 */
proto.proto.Entity.BandConfigInfo.prototype.setIoslogo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string androidLogo = 5;
 * @return {string}
 */
proto.proto.Entity.BandConfigInfo.prototype.getAndroidlogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.BandConfigInfo} returns this
 */
proto.proto.Entity.BandConfigInfo.prototype.setAndroidlogo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string glassesLogo = 6;
 * @return {string}
 */
proto.proto.Entity.BandConfigInfo.prototype.getGlasseslogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.BandConfigInfo} returns this
 */
proto.proto.Entity.BandConfigInfo.prototype.setGlasseslogo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool enableAboutInfo = 7;
 * @return {boolean}
 */
proto.proto.Entity.BandConfigInfo.prototype.getEnableaboutinfo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.BandConfigInfo} returns this
 */
proto.proto.Entity.BandConfigInfo.prototype.setEnableaboutinfo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ServerConfigInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ServerConfigInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ServerConfigInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ServerConfigInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    protocol: jspb.Message.getFieldWithDefault(msg, 1, 0),
    serverenvindex: jspb.Message.getFieldWithDefault(msg, 2, 0),
    serveraddress: jspb.Message.getFieldWithDefault(msg, 3, ""),
    serverport: jspb.Message.getFieldWithDefault(msg, 4, ""),
    disablesslverify: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ServerConfigInfo}
 */
proto.proto.Entity.ServerConfigInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ServerConfigInfo;
  return proto.proto.Entity.ServerConfigInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ServerConfigInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ServerConfigInfo}
 */
proto.proto.Entity.ServerConfigInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProtocol(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setServerenvindex(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setServeraddress(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerport(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisablesslverify(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ServerConfigInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ServerConfigInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ServerConfigInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ServerConfigInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProtocol();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getServerenvindex();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getServeraddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getServerport();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisablesslverify();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional uint32 protocol = 1;
 * @return {number}
 */
proto.proto.Entity.ServerConfigInfo.prototype.getProtocol = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ServerConfigInfo} returns this
 */
proto.proto.Entity.ServerConfigInfo.prototype.setProtocol = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 serverEnvIndex = 2;
 * @return {number}
 */
proto.proto.Entity.ServerConfigInfo.prototype.getServerenvindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ServerConfigInfo} returns this
 */
proto.proto.Entity.ServerConfigInfo.prototype.setServerenvindex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string serverAddress = 3;
 * @return {string}
 */
proto.proto.Entity.ServerConfigInfo.prototype.getServeraddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ServerConfigInfo} returns this
 */
proto.proto.Entity.ServerConfigInfo.prototype.setServeraddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string serverPort = 4;
 * @return {string}
 */
proto.proto.Entity.ServerConfigInfo.prototype.getServerport = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ServerConfigInfo} returns this
 */
proto.proto.Entity.ServerConfigInfo.prototype.setServerport = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool disableSSLVerify = 5;
 * @return {boolean}
 */
proto.proto.Entity.ServerConfigInfo.prototype.getDisablesslverify = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ServerConfigInfo} returns this
 */
proto.proto.Entity.ServerConfigInfo.prototype.setDisablesslverify = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.AccountInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.AccountInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.AccountInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AccountInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    timestamp: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    hasphoto: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    username: jspb.Message.getFieldWithDefault(msg, 4, ""),
    password: jspb.Message.getFieldWithDefault(msg, 5, ""),
    token: jspb.Message.getFieldWithDefault(msg, 6, ""),
    avatarurl: jspb.Message.getFieldWithDefault(msg, 7, ""),
    enablerememberpassword: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.AccountInfo}
 */
proto.proto.Entity.AccountInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.AccountInfo;
  return proto.proto.Entity.AccountInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.AccountInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.AccountInfo}
 */
proto.proto.Entity.AccountInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasphoto(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarurl(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablerememberpassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.AccountInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.AccountInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.AccountInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AccountInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHasphoto();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAvatarurl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEnablerememberpassword();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional uint64 timeStamp = 1;
 * @return {number}
 */
proto.proto.Entity.AccountInfo.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.AccountInfo} returns this
 */
proto.proto.Entity.AccountInfo.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string userID = 2;
 * @return {string}
 */
proto.proto.Entity.AccountInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AccountInfo} returns this
 */
proto.proto.Entity.AccountInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool hasPhoto = 3;
 * @return {boolean}
 */
proto.proto.Entity.AccountInfo.prototype.getHasphoto = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.AccountInfo} returns this
 */
proto.proto.Entity.AccountInfo.prototype.setHasphoto = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string userName = 4;
 * @return {string}
 */
proto.proto.Entity.AccountInfo.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AccountInfo} returns this
 */
proto.proto.Entity.AccountInfo.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string password = 5;
 * @return {string}
 */
proto.proto.Entity.AccountInfo.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AccountInfo} returns this
 */
proto.proto.Entity.AccountInfo.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string token = 6;
 * @return {string}
 */
proto.proto.Entity.AccountInfo.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AccountInfo} returns this
 */
proto.proto.Entity.AccountInfo.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string avatarUrl = 7;
 * @return {string}
 */
proto.proto.Entity.AccountInfo.prototype.getAvatarurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AccountInfo} returns this
 */
proto.proto.Entity.AccountInfo.prototype.setAvatarurl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool enableRememberPassword = 8;
 * @return {boolean}
 */
proto.proto.Entity.AccountInfo.prototype.getEnablerememberpassword = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.AccountInfo} returns this
 */
proto.proto.Entity.AccountInfo.prototype.setEnablerememberpassword = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.AccountData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.AccountData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.AccountData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.AccountData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AccountData.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountsList: jspb.Message.toObjectList(msg.getAccountsList(),
    proto.proto.Entity.AccountInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.AccountData}
 */
proto.proto.Entity.AccountData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.AccountData;
  return proto.proto.Entity.AccountData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.AccountData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.AccountData}
 */
proto.proto.Entity.AccountData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.AccountInfo;
      reader.readMessage(value,proto.proto.Entity.AccountInfo.deserializeBinaryFromReader);
      msg.addAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.AccountData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.AccountData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.AccountData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AccountData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.AccountInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AccountInfo accounts = 1;
 * @return {!Array<!proto.proto.Entity.AccountInfo>}
 */
proto.proto.Entity.AccountData.prototype.getAccountsList = function() {
  return /** @type{!Array<!proto.proto.Entity.AccountInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.AccountInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.AccountInfo>} value
 * @return {!proto.proto.Entity.AccountData} returns this
*/
proto.proto.Entity.AccountData.prototype.setAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.AccountInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.AccountInfo}
 */
proto.proto.Entity.AccountData.prototype.addAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.AccountInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.AccountData} returns this
 */
proto.proto.Entity.AccountData.prototype.clearAccountsList = function() {
  return this.setAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.UserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.UserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.UserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.UserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 4, ""),
    loginname: jspb.Message.getFieldWithDefault(msg, 5, ""),
    corpid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    corpname: jspb.Message.getFieldWithDefault(msg, 7, ""),
    gender: jspb.Message.getFieldWithDefault(msg, 8, 0),
    avatarurl: jspb.Message.getFieldWithDefault(msg, 9, ""),
    namespell: jspb.Message.getFieldWithDefault(msg, 10, ""),
    position: jspb.Message.getFieldWithDefault(msg, 11, ""),
    token: jspb.Message.getFieldWithDefault(msg, 12, ""),
    systemnotification: jspb.Message.getFieldWithDefault(msg, 13, ""),
    baidumapkey: jspb.Message.getFieldWithDefault(msg, 14, ""),
    hasphoto: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    enablelivestream: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    enablewatchlivestream: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
    enablepulllivestream: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    enableremoteconverse: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
    disablemapview: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
    enableinspection: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    enablederegister: jspb.Message.getBooleanFieldWithDefault(msg, 22, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.UserInfo}
 */
proto.proto.Entity.UserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.UserInfo;
  return proto.proto.Entity.UserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.UserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.UserInfo}
 */
proto.proto.Entity.UserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpname(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setGender(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarurl(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespell(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPosition(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setSystemnotification(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setBaidumapkey(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasphoto(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablelivestream(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablewatchlivestream(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablepulllivestream(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableremoteconverse(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisablemapview(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableinspection(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnablederegister(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.UserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.UserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.UserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.UserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLoginname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCorpname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getGender();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getAvatarurl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getNamespell();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPosition();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getSystemnotification();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getBaidumapkey();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getHasphoto();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getEnablelivestream();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getEnablewatchlivestream();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getEnablepulllivestream();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getEnableremoteconverse();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getDisablemapview();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getEnableinspection();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getEnablederegister();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
};


/**
 * optional string userID = 1;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mobile = 4;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string loginName = 5;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getLoginname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setLoginname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string corpID = 6;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string corpName = 7;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getCorpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setCorpname = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint32 gender = 8;
 * @return {number}
 */
proto.proto.Entity.UserInfo.prototype.getGender = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setGender = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string avatarUrl = 9;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getAvatarurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setAvatarurl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string nameSpell = 10;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getNamespell = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setNamespell = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string position = 11;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getPosition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setPosition = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string token = 12;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string systemNotification = 13;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getSystemnotification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setSystemnotification = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string baiduMapKey = 14;
 * @return {string}
 */
proto.proto.Entity.UserInfo.prototype.getBaidumapkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setBaidumapkey = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool hasPhoto = 15;
 * @return {boolean}
 */
proto.proto.Entity.UserInfo.prototype.getHasphoto = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setHasphoto = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool enableLiveStream = 16;
 * @return {boolean}
 */
proto.proto.Entity.UserInfo.prototype.getEnablelivestream = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setEnablelivestream = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional bool enablewatchLiveStream = 17;
 * @return {boolean}
 */
proto.proto.Entity.UserInfo.prototype.getEnablewatchlivestream = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setEnablewatchlivestream = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional bool enablePullLiveStream = 18;
 * @return {boolean}
 */
proto.proto.Entity.UserInfo.prototype.getEnablepulllivestream = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setEnablepulllivestream = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional bool enableRemoteConverse = 19;
 * @return {boolean}
 */
proto.proto.Entity.UserInfo.prototype.getEnableremoteconverse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setEnableremoteconverse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional bool disableMapView = 20;
 * @return {boolean}
 */
proto.proto.Entity.UserInfo.prototype.getDisablemapview = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setDisablemapview = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional bool enableInspection = 21;
 * @return {boolean}
 */
proto.proto.Entity.UserInfo.prototype.getEnableinspection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setEnableinspection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional bool enableDeregister = 22;
 * @return {boolean}
 */
proto.proto.Entity.UserInfo.prototype.getEnablederegister = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.UserInfo} returns this
 */
proto.proto.Entity.UserInfo.prototype.setEnablederegister = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ContactInfo.repeatedFields_ = [18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ContactInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ContactInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ContactInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ContactInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    hasphoto: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    islocalcorp: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    enableshare: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    mobile: jspb.Message.getFieldWithDefault(msg, 5, ""),
    loginname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    email: jspb.Message.getFieldWithDefault(msg, 7, ""),
    name: jspb.Message.getFieldWithDefault(msg, 8, ""),
    avatarurl: jspb.Message.getFieldWithDefault(msg, 9, ""),
    corpid: jspb.Message.getFieldWithDefault(msg, 10, ""),
    corpname: jspb.Message.getFieldWithDefault(msg, 11, ""),
    position: jspb.Message.getFieldWithDefault(msg, 12, ""),
    namespell: jspb.Message.getFieldWithDefault(msg, 13, ""),
    letter: jspb.Message.getFieldWithDefault(msg, 14, ""),
    searchstring: jspb.Message.getFieldWithDefault(msg, 15, ""),
    addusername: jspb.Message.getFieldWithDefault(msg, 16, ""),
    gender: jspb.Message.getFieldWithDefault(msg, 17, 0),
    ownerorglistList: (f = jspb.Message.getRepeatedField(msg, 18)) == null ? undefined : f,
    status: jspb.Message.getFieldWithDefault(msg, 19, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ContactInfo}
 */
proto.proto.Entity.ContactInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ContactInfo;
  return proto.proto.Entity.ContactInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ContactInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ContactInfo}
 */
proto.proto.Entity.ContactInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasphoto(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIslocalcorp(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableshare(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginname(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarurl(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpname(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setPosition(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespell(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setLetter(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchstring(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddusername(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setGender(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.addOwnerorglist(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ContactInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ContactInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ContactInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ContactInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHasphoto();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIslocalcorp();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getEnableshare();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLoginname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAvatarurl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCorpname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPosition();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getNamespell();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getLetter();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getSearchstring();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getAddusername();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getGender();
  if (f !== 0) {
    writer.writeUint32(
      17,
      f
    );
  }
  f = message.getOwnerorglistList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      18,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      19,
      f
    );
  }
};


/**
 * optional string userID = 1;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool hasPhoto = 2;
 * @return {boolean}
 */
proto.proto.Entity.ContactInfo.prototype.getHasphoto = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setHasphoto = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool isLocalCorp = 3;
 * @return {boolean}
 */
proto.proto.Entity.ContactInfo.prototype.getIslocalcorp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setIslocalcorp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool enableShare = 4;
 * @return {boolean}
 */
proto.proto.Entity.ContactInfo.prototype.getEnableshare = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setEnableshare = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string mobile = 5;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string loginName = 6;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getLoginname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setLoginname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string email = 7;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string name = 8;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string avatarUrl = 9;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getAvatarurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setAvatarurl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string corpId = 10;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string corpName = 11;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getCorpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setCorpname = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string position = 12;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getPosition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setPosition = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string nameSpell = 13;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getNamespell = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setNamespell = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string letter = 14;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getLetter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setLetter = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string searchString = 15;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getSearchstring = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setSearchstring = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string addUserName = 16;
 * @return {string}
 */
proto.proto.Entity.ContactInfo.prototype.getAddusername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setAddusername = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional uint32 gender = 17;
 * @return {number}
 */
proto.proto.Entity.ContactInfo.prototype.getGender = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setGender = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * repeated string ownerOrgList = 18;
 * @return {!Array<string>}
 */
proto.proto.Entity.ContactInfo.prototype.getOwnerorglistList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 18));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setOwnerorglistList = function(value) {
  return jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.addOwnerorglist = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.clearOwnerorglistList = function() {
  return this.setOwnerorglistList([]);
};


/**
 * optional uint32 status = 19;
 * @return {number}
 */
proto.proto.Entity.ContactInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ContactInfo} returns this
 */
proto.proto.Entity.ContactInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.UserStatusInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.UserStatusInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.UserStatusInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.UserStatusInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    devicetype: jspb.Message.getFieldWithDefault(msg, 2, 0),
    onlinestatus: jspb.Message.getFieldWithDefault(msg, 3, 0),
    offlinereason: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.UserStatusInfo}
 */
proto.proto.Entity.UserStatusInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.UserStatusInfo;
  return proto.proto.Entity.UserStatusInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.UserStatusInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.UserStatusInfo}
 */
proto.proto.Entity.UserStatusInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDevicetype(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOnlinestatus(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOfflinereason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.UserStatusInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.UserStatusInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.UserStatusInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.UserStatusInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDevicetype();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getOnlinestatus();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getOfflinereason();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional string userID = 1;
 * @return {string}
 */
proto.proto.Entity.UserStatusInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UserStatusInfo} returns this
 */
proto.proto.Entity.UserStatusInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 deviceType = 2;
 * @return {number}
 */
proto.proto.Entity.UserStatusInfo.prototype.getDevicetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.UserStatusInfo} returns this
 */
proto.proto.Entity.UserStatusInfo.prototype.setDevicetype = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 onlineStatus = 3;
 * @return {number}
 */
proto.proto.Entity.UserStatusInfo.prototype.getOnlinestatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.UserStatusInfo} returns this
 */
proto.proto.Entity.UserStatusInfo.prototype.setOnlinestatus = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 offlineReason = 4;
 * @return {number}
 */
proto.proto.Entity.UserStatusInfo.prototype.getOfflinereason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.UserStatusInfo} returns this
 */
proto.proto.Entity.UserStatusInfo.prototype.setOfflinereason = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.UserStatusData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.UserStatusData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.UserStatusData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.UserStatusData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.UserStatusData.toObject = function(includeInstance, msg) {
  var f, obj = {
    userstatuarrayList: jspb.Message.toObjectList(msg.getUserstatuarrayList(),
    proto.proto.Entity.UserStatusInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.UserStatusData}
 */
proto.proto.Entity.UserStatusData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.UserStatusData;
  return proto.proto.Entity.UserStatusData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.UserStatusData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.UserStatusData}
 */
proto.proto.Entity.UserStatusData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.UserStatusInfo;
      reader.readMessage(value,proto.proto.Entity.UserStatusInfo.deserializeBinaryFromReader);
      msg.addUserstatuarray(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.UserStatusData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.UserStatusData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.UserStatusData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.UserStatusData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserstatuarrayList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.UserStatusInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserStatusInfo userStatuArray = 1;
 * @return {!Array<!proto.proto.Entity.UserStatusInfo>}
 */
proto.proto.Entity.UserStatusData.prototype.getUserstatuarrayList = function() {
  return /** @type{!Array<!proto.proto.Entity.UserStatusInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.UserStatusInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.UserStatusInfo>} value
 * @return {!proto.proto.Entity.UserStatusData} returns this
*/
proto.proto.Entity.UserStatusData.prototype.setUserstatuarrayList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.UserStatusInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.UserStatusInfo}
 */
proto.proto.Entity.UserStatusData.prototype.addUserstatuarray = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.UserStatusInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.UserStatusData} returns this
 */
proto.proto.Entity.UserStatusData.prototype.clearUserstatuarrayList = function() {
  return this.setUserstatuarrayList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.MqttConfigInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.MqttConfigInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.MqttConfigInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.MqttConfigInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    serveraddress: jspb.Message.getFieldWithDefault(msg, 1, ""),
    subscribetopic: jspb.Message.getFieldWithDefault(msg, 2, ""),
    publishtopic: jspb.Message.getFieldWithDefault(msg, 3, ""),
    p2ptopicprefix: jspb.Message.getFieldWithDefault(msg, 4, ""),
    subuserstatustopic: jspb.Message.getFieldWithDefault(msg, 5, ""),
    subgroupstatustopic: jspb.Message.getFieldWithDefault(msg, 6, ""),
    subcorptopic: jspb.Message.getFieldWithDefault(msg, 7, ""),
    loginpassword: jspb.Message.getFieldWithDefault(msg, 8, ""),
    clientid: jspb.Message.getFieldWithDefault(msg, 9, ""),
    username: jspb.Message.getFieldWithDefault(msg, 10, ""),
    password: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.MqttConfigInfo}
 */
proto.proto.Entity.MqttConfigInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.MqttConfigInfo;
  return proto.proto.Entity.MqttConfigInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.MqttConfigInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.MqttConfigInfo}
 */
proto.proto.Entity.MqttConfigInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServeraddress(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscribetopic(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublishtopic(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setP2ptopicprefix(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubuserstatustopic(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubgroupstatustopic(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubcorptopic(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginpassword(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.MqttConfigInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.MqttConfigInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.MqttConfigInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.MqttConfigInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServeraddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscribetopic();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPublishtopic();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getP2ptopicprefix();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubuserstatustopic();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSubgroupstatustopic();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSubcorptopic();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLoginpassword();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getClientid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string serverAddress = 1;
 * @return {string}
 */
proto.proto.Entity.MqttConfigInfo.prototype.getServeraddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.MqttConfigInfo} returns this
 */
proto.proto.Entity.MqttConfigInfo.prototype.setServeraddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscribeTopic = 2;
 * @return {string}
 */
proto.proto.Entity.MqttConfigInfo.prototype.getSubscribetopic = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.MqttConfigInfo} returns this
 */
proto.proto.Entity.MqttConfigInfo.prototype.setSubscribetopic = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string publishTopic = 3;
 * @return {string}
 */
proto.proto.Entity.MqttConfigInfo.prototype.getPublishtopic = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.MqttConfigInfo} returns this
 */
proto.proto.Entity.MqttConfigInfo.prototype.setPublishtopic = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string p2PTopicPrefix = 4;
 * @return {string}
 */
proto.proto.Entity.MqttConfigInfo.prototype.getP2ptopicprefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.MqttConfigInfo} returns this
 */
proto.proto.Entity.MqttConfigInfo.prototype.setP2ptopicprefix = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string subUserStatusTopic = 5;
 * @return {string}
 */
proto.proto.Entity.MqttConfigInfo.prototype.getSubuserstatustopic = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.MqttConfigInfo} returns this
 */
proto.proto.Entity.MqttConfigInfo.prototype.setSubuserstatustopic = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string subGroupStatusTopic = 6;
 * @return {string}
 */
proto.proto.Entity.MqttConfigInfo.prototype.getSubgroupstatustopic = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.MqttConfigInfo} returns this
 */
proto.proto.Entity.MqttConfigInfo.prototype.setSubgroupstatustopic = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string subCorpTopic = 7;
 * @return {string}
 */
proto.proto.Entity.MqttConfigInfo.prototype.getSubcorptopic = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.MqttConfigInfo} returns this
 */
proto.proto.Entity.MqttConfigInfo.prototype.setSubcorptopic = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string loginPassword = 8;
 * @return {string}
 */
proto.proto.Entity.MqttConfigInfo.prototype.getLoginpassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.MqttConfigInfo} returns this
 */
proto.proto.Entity.MqttConfigInfo.prototype.setLoginpassword = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string clientID = 9;
 * @return {string}
 */
proto.proto.Entity.MqttConfigInfo.prototype.getClientid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.MqttConfigInfo} returns this
 */
proto.proto.Entity.MqttConfigInfo.prototype.setClientid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string username = 10;
 * @return {string}
 */
proto.proto.Entity.MqttConfigInfo.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.MqttConfigInfo} returns this
 */
proto.proto.Entity.MqttConfigInfo.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string password = 11;
 * @return {string}
 */
proto.proto.Entity.MqttConfigInfo.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.MqttConfigInfo} returns this
 */
proto.proto.Entity.MqttConfigInfo.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.AgoraConfigInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.AgoraConfigInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.AgoraConfigInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AgoraConfigInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    appkey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    address: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mode: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.AgoraConfigInfo}
 */
proto.proto.Entity.AgoraConfigInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.AgoraConfigInfo;
  return proto.proto.Entity.AgoraConfigInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.AgoraConfigInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.AgoraConfigInfo}
 */
proto.proto.Entity.AgoraConfigInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppkey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.AgoraConfigInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.AgoraConfigInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.AgoraConfigInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AgoraConfigInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppkey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string appKey = 1;
 * @return {string}
 */
proto.proto.Entity.AgoraConfigInfo.prototype.getAppkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AgoraConfigInfo} returns this
 */
proto.proto.Entity.AgoraConfigInfo.prototype.setAppkey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string address = 2;
 * @return {string}
 */
proto.proto.Entity.AgoraConfigInfo.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AgoraConfigInfo} returns this
 */
proto.proto.Entity.AgoraConfigInfo.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string mode = 3;
 * @return {string}
 */
proto.proto.Entity.AgoraConfigInfo.prototype.getMode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AgoraConfigInfo} returns this
 */
proto.proto.Entity.AgoraConfigInfo.prototype.setMode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.HisRtcConfigInfo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.HisRtcConfigInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.HisRtcConfigInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.HisRtcConfigInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.HisRtcConfigInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    appkey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    appsecret: jspb.Message.getFieldWithDefault(msg, 2, ""),
    serveraddressList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.HisRtcConfigInfo}
 */
proto.proto.Entity.HisRtcConfigInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.HisRtcConfigInfo;
  return proto.proto.Entity.HisRtcConfigInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.HisRtcConfigInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.HisRtcConfigInfo}
 */
proto.proto.Entity.HisRtcConfigInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppkey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppsecret(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addServeraddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.HisRtcConfigInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.HisRtcConfigInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.HisRtcConfigInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.HisRtcConfigInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppkey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAppsecret();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getServeraddressList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string appKey = 1;
 * @return {string}
 */
proto.proto.Entity.HisRtcConfigInfo.prototype.getAppkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.HisRtcConfigInfo} returns this
 */
proto.proto.Entity.HisRtcConfigInfo.prototype.setAppkey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string appSecret = 2;
 * @return {string}
 */
proto.proto.Entity.HisRtcConfigInfo.prototype.getAppsecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.HisRtcConfigInfo} returns this
 */
proto.proto.Entity.HisRtcConfigInfo.prototype.setAppsecret = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string serverAddress = 3;
 * @return {!Array<string>}
 */
proto.proto.Entity.HisRtcConfigInfo.prototype.getServeraddressList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.HisRtcConfigInfo} returns this
 */
proto.proto.Entity.HisRtcConfigInfo.prototype.setServeraddressList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.HisRtcConfigInfo} returns this
 */
proto.proto.Entity.HisRtcConfigInfo.prototype.addServeraddress = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.HisRtcConfigInfo} returns this
 */
proto.proto.Entity.HisRtcConfigInfo.prototype.clearServeraddressList = function() {
  return this.setServeraddressList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.LeiaRtcConfigInfo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.LeiaRtcConfigInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.LeiaRtcConfigInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.LeiaRtcConfigInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.LeiaRtcConfigInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    appkey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    serveraddressList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.LeiaRtcConfigInfo}
 */
proto.proto.Entity.LeiaRtcConfigInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.LeiaRtcConfigInfo;
  return proto.proto.Entity.LeiaRtcConfigInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.LeiaRtcConfigInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.LeiaRtcConfigInfo}
 */
proto.proto.Entity.LeiaRtcConfigInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppkey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addServeraddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.LeiaRtcConfigInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.LeiaRtcConfigInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.LeiaRtcConfigInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.LeiaRtcConfigInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAppkey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getServeraddressList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string appId = 1;
 * @return {string}
 */
proto.proto.Entity.LeiaRtcConfigInfo.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LeiaRtcConfigInfo} returns this
 */
proto.proto.Entity.LeiaRtcConfigInfo.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string appKey = 2;
 * @return {string}
 */
proto.proto.Entity.LeiaRtcConfigInfo.prototype.getAppkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LeiaRtcConfigInfo} returns this
 */
proto.proto.Entity.LeiaRtcConfigInfo.prototype.setAppkey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string serverAddress = 3;
 * @return {!Array<string>}
 */
proto.proto.Entity.LeiaRtcConfigInfo.prototype.getServeraddressList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.LeiaRtcConfigInfo} returns this
 */
proto.proto.Entity.LeiaRtcConfigInfo.prototype.setServeraddressList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.LeiaRtcConfigInfo} returns this
 */
proto.proto.Entity.LeiaRtcConfigInfo.prototype.addServeraddress = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.LeiaRtcConfigInfo} returns this
 */
proto.proto.Entity.LeiaRtcConfigInfo.prototype.clearServeraddressList = function() {
  return this.setServeraddressList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.IMServerConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.IMServerConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.IMServerConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.IMServerConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    fileserveraddress: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.IMServerConfig}
 */
proto.proto.Entity.IMServerConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.IMServerConfig;
  return proto.proto.Entity.IMServerConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.IMServerConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.IMServerConfig}
 */
proto.proto.Entity.IMServerConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileserveraddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.IMServerConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.IMServerConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.IMServerConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.IMServerConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileserveraddress();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string fileServerAddress = 1;
 * @return {string}
 */
proto.proto.Entity.IMServerConfig.prototype.getFileserveraddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.IMServerConfig} returns this
 */
proto.proto.Entity.IMServerConfig.prototype.setFileserveraddress = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ToolkitConfigInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ToolkitConfigInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ToolkitConfigInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ToolkitConfigInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    appid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    appsecret: jspb.Message.getFieldWithDefault(msg, 2, ""),
    hmacaccesskey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    hmacsecretkey: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ToolkitConfigInfo}
 */
proto.proto.Entity.ToolkitConfigInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ToolkitConfigInfo;
  return proto.proto.Entity.ToolkitConfigInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ToolkitConfigInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ToolkitConfigInfo}
 */
proto.proto.Entity.ToolkitConfigInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppsecret(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHmacaccesskey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHmacsecretkey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ToolkitConfigInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ToolkitConfigInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ToolkitConfigInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ToolkitConfigInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAppsecret();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHmacaccesskey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHmacsecretkey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string appId = 1;
 * @return {string}
 */
proto.proto.Entity.ToolkitConfigInfo.prototype.getAppid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ToolkitConfigInfo} returns this
 */
proto.proto.Entity.ToolkitConfigInfo.prototype.setAppid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string appSecret = 2;
 * @return {string}
 */
proto.proto.Entity.ToolkitConfigInfo.prototype.getAppsecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ToolkitConfigInfo} returns this
 */
proto.proto.Entity.ToolkitConfigInfo.prototype.setAppsecret = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string hmacAccessKey = 3;
 * @return {string}
 */
proto.proto.Entity.ToolkitConfigInfo.prototype.getHmacaccesskey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ToolkitConfigInfo} returns this
 */
proto.proto.Entity.ToolkitConfigInfo.prototype.setHmacaccesskey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string hmacSecretKey = 4;
 * @return {string}
 */
proto.proto.Entity.ToolkitConfigInfo.prototype.getHmacsecretkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ToolkitConfigInfo} returns this
 */
proto.proto.Entity.ToolkitConfigInfo.prototype.setHmacsecretkey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConfigInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConfigInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConfigInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConfigInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    videorecordenable: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    mqtt: (f = msg.getMqtt()) && proto.proto.Entity.MqttConfigInfo.toObject(includeInstance, f),
    mediaengine: (f = msg.getMediaengine()) && proto.proto.Entity.MediaEngineConfigInfo.toObject(includeInstance, f),
    imserverconfig: (f = msg.getImserverconfig()) && proto.proto.Entity.IMServerConfig.toObject(includeInstance, f),
    maxroommember: jspb.Message.getFieldWithDefault(msg, 5, 0),
    fps: jspb.Message.getFieldWithDefault(msg, 6, 0),
    toolkitconfiginfo: (f = msg.getToolkitconfiginfo()) && proto.proto.Entity.ToolkitConfigInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConfigInfo}
 */
proto.proto.Entity.ConfigInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConfigInfo;
  return proto.proto.Entity.ConfigInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConfigInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConfigInfo}
 */
proto.proto.Entity.ConfigInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVideorecordenable(value);
      break;
    case 2:
      var value = new proto.proto.Entity.MqttConfigInfo;
      reader.readMessage(value,proto.proto.Entity.MqttConfigInfo.deserializeBinaryFromReader);
      msg.setMqtt(value);
      break;
    case 3:
      var value = new proto.proto.Entity.MediaEngineConfigInfo;
      reader.readMessage(value,proto.proto.Entity.MediaEngineConfigInfo.deserializeBinaryFromReader);
      msg.setMediaengine(value);
      break;
    case 4:
      var value = new proto.proto.Entity.IMServerConfig;
      reader.readMessage(value,proto.proto.Entity.IMServerConfig.deserializeBinaryFromReader);
      msg.setImserverconfig(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxroommember(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFps(value);
      break;
    case 7:
      var value = new proto.proto.Entity.ToolkitConfigInfo;
      reader.readMessage(value,proto.proto.Entity.ToolkitConfigInfo.deserializeBinaryFromReader);
      msg.setToolkitconfiginfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConfigInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConfigInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConfigInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConfigInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideorecordenable();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getMqtt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.Entity.MqttConfigInfo.serializeBinaryToWriter
    );
  }
  f = message.getMediaengine();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.Entity.MediaEngineConfigInfo.serializeBinaryToWriter
    );
  }
  f = message.getImserverconfig();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.proto.Entity.IMServerConfig.serializeBinaryToWriter
    );
  }
  f = message.getMaxroommember();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getFps();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getToolkitconfiginfo();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.proto.Entity.ToolkitConfigInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool videoRecordEnable = 1;
 * @return {boolean}
 */
proto.proto.Entity.ConfigInfo.prototype.getVideorecordenable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ConfigInfo} returns this
 */
proto.proto.Entity.ConfigInfo.prototype.setVideorecordenable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional MqttConfigInfo mqtt = 2;
 * @return {?proto.proto.Entity.MqttConfigInfo}
 */
proto.proto.Entity.ConfigInfo.prototype.getMqtt = function() {
  return /** @type{?proto.proto.Entity.MqttConfigInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.MqttConfigInfo, 2));
};


/**
 * @param {?proto.proto.Entity.MqttConfigInfo|undefined} value
 * @return {!proto.proto.Entity.ConfigInfo} returns this
*/
proto.proto.Entity.ConfigInfo.prototype.setMqtt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.ConfigInfo} returns this
 */
proto.proto.Entity.ConfigInfo.prototype.clearMqtt = function() {
  return this.setMqtt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.ConfigInfo.prototype.hasMqtt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MediaEngineConfigInfo mediaEngine = 3;
 * @return {?proto.proto.Entity.MediaEngineConfigInfo}
 */
proto.proto.Entity.ConfigInfo.prototype.getMediaengine = function() {
  return /** @type{?proto.proto.Entity.MediaEngineConfigInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.MediaEngineConfigInfo, 3));
};


/**
 * @param {?proto.proto.Entity.MediaEngineConfigInfo|undefined} value
 * @return {!proto.proto.Entity.ConfigInfo} returns this
*/
proto.proto.Entity.ConfigInfo.prototype.setMediaengine = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.ConfigInfo} returns this
 */
proto.proto.Entity.ConfigInfo.prototype.clearMediaengine = function() {
  return this.setMediaengine(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.ConfigInfo.prototype.hasMediaengine = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional IMServerConfig imServerConfig = 4;
 * @return {?proto.proto.Entity.IMServerConfig}
 */
proto.proto.Entity.ConfigInfo.prototype.getImserverconfig = function() {
  return /** @type{?proto.proto.Entity.IMServerConfig} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.IMServerConfig, 4));
};


/**
 * @param {?proto.proto.Entity.IMServerConfig|undefined} value
 * @return {!proto.proto.Entity.ConfigInfo} returns this
*/
proto.proto.Entity.ConfigInfo.prototype.setImserverconfig = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.ConfigInfo} returns this
 */
proto.proto.Entity.ConfigInfo.prototype.clearImserverconfig = function() {
  return this.setImserverconfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.ConfigInfo.prototype.hasImserverconfig = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional uint32 maxRoomMember = 5;
 * @return {number}
 */
proto.proto.Entity.ConfigInfo.prototype.getMaxroommember = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConfigInfo} returns this
 */
proto.proto.Entity.ConfigInfo.prototype.setMaxroommember = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 fps = 6;
 * @return {number}
 */
proto.proto.Entity.ConfigInfo.prototype.getFps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConfigInfo} returns this
 */
proto.proto.Entity.ConfigInfo.prototype.setFps = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional ToolkitConfigInfo toolkitConfigInfo = 7;
 * @return {?proto.proto.Entity.ToolkitConfigInfo}
 */
proto.proto.Entity.ConfigInfo.prototype.getToolkitconfiginfo = function() {
  return /** @type{?proto.proto.Entity.ToolkitConfigInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.ToolkitConfigInfo, 7));
};


/**
 * @param {?proto.proto.Entity.ToolkitConfigInfo|undefined} value
 * @return {!proto.proto.Entity.ConfigInfo} returns this
*/
proto.proto.Entity.ConfigInfo.prototype.setToolkitconfiginfo = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.ConfigInfo} returns this
 */
proto.proto.Entity.ConfigInfo.prototype.clearToolkitconfiginfo = function() {
  return this.setToolkitconfiginfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.ConfigInfo.prototype.hasToolkitconfiginfo = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.MediaEngineConfigInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.MediaEngineConfigInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.MediaEngineConfigInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    mediatype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    agora: (f = msg.getAgora()) && proto.proto.Entity.AgoraConfigInfo.toObject(includeInstance, f),
    hisrtc: (f = msg.getHisrtc()) && proto.proto.Entity.HisRtcConfigInfo.toObject(includeInstance, f),
    leiartc: (f = msg.getLeiartc()) && proto.proto.Entity.LeiaRtcConfigInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.MediaEngineConfigInfo}
 */
proto.proto.Entity.MediaEngineConfigInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.MediaEngineConfigInfo;
  return proto.proto.Entity.MediaEngineConfigInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.MediaEngineConfigInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.MediaEngineConfigInfo}
 */
proto.proto.Entity.MediaEngineConfigInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMediatype(value);
      break;
    case 2:
      var value = new proto.proto.Entity.AgoraConfigInfo;
      reader.readMessage(value,proto.proto.Entity.AgoraConfigInfo.deserializeBinaryFromReader);
      msg.setAgora(value);
      break;
    case 3:
      var value = new proto.proto.Entity.HisRtcConfigInfo;
      reader.readMessage(value,proto.proto.Entity.HisRtcConfigInfo.deserializeBinaryFromReader);
      msg.setHisrtc(value);
      break;
    case 4:
      var value = new proto.proto.Entity.LeiaRtcConfigInfo;
      reader.readMessage(value,proto.proto.Entity.LeiaRtcConfigInfo.deserializeBinaryFromReader);
      msg.setLeiartc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.MediaEngineConfigInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.MediaEngineConfigInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.MediaEngineConfigInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMediatype();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getAgora();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.Entity.AgoraConfigInfo.serializeBinaryToWriter
    );
  }
  f = message.getHisrtc();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.Entity.HisRtcConfigInfo.serializeBinaryToWriter
    );
  }
  f = message.getLeiartc();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.proto.Entity.LeiaRtcConfigInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 mediaType = 1;
 * @return {number}
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.getMediatype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.MediaEngineConfigInfo} returns this
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.setMediatype = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional AgoraConfigInfo agora = 2;
 * @return {?proto.proto.Entity.AgoraConfigInfo}
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.getAgora = function() {
  return /** @type{?proto.proto.Entity.AgoraConfigInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.AgoraConfigInfo, 2));
};


/**
 * @param {?proto.proto.Entity.AgoraConfigInfo|undefined} value
 * @return {!proto.proto.Entity.MediaEngineConfigInfo} returns this
*/
proto.proto.Entity.MediaEngineConfigInfo.prototype.setAgora = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.MediaEngineConfigInfo} returns this
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.clearAgora = function() {
  return this.setAgora(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.hasAgora = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional HisRtcConfigInfo hisrtc = 3;
 * @return {?proto.proto.Entity.HisRtcConfigInfo}
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.getHisrtc = function() {
  return /** @type{?proto.proto.Entity.HisRtcConfigInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.HisRtcConfigInfo, 3));
};


/**
 * @param {?proto.proto.Entity.HisRtcConfigInfo|undefined} value
 * @return {!proto.proto.Entity.MediaEngineConfigInfo} returns this
*/
proto.proto.Entity.MediaEngineConfigInfo.prototype.setHisrtc = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.MediaEngineConfigInfo} returns this
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.clearHisrtc = function() {
  return this.setHisrtc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.hasHisrtc = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional LeiaRtcConfigInfo leiartc = 4;
 * @return {?proto.proto.Entity.LeiaRtcConfigInfo}
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.getLeiartc = function() {
  return /** @type{?proto.proto.Entity.LeiaRtcConfigInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.LeiaRtcConfigInfo, 4));
};


/**
 * @param {?proto.proto.Entity.LeiaRtcConfigInfo|undefined} value
 * @return {!proto.proto.Entity.MediaEngineConfigInfo} returns this
*/
proto.proto.Entity.MediaEngineConfigInfo.prototype.setLeiartc = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.MediaEngineConfigInfo} returns this
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.clearLeiartc = function() {
  return this.setLeiartc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.MediaEngineConfigInfo.prototype.hasLeiartc = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.LatestVersionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.LatestVersionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.LatestVersionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.LatestVersionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    versioncode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    isforceupdate: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    appid: jspb.Message.getFieldWithDefault(msg, 5, 0),
    createtime: jspb.Message.getFieldWithDefault(msg, 6, 0),
    name: jspb.Message.getFieldWithDefault(msg, 7, ""),
    version: jspb.Message.getFieldWithDefault(msg, 8, ""),
    downloadurl: jspb.Message.getFieldWithDefault(msg, 9, ""),
    filemd5: jspb.Message.getFieldWithDefault(msg, 10, ""),
    description: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.LatestVersionInfo}
 */
proto.proto.Entity.LatestVersionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.LatestVersionInfo;
  return proto.proto.Entity.LatestVersionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.LatestVersionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.LatestVersionInfo}
 */
proto.proto.Entity.LatestVersionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVersioncode(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsforceupdate(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAppid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCreatetime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadurl(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilemd5(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.LatestVersionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.LatestVersionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.LatestVersionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.LatestVersionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getVersioncode();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getIsforceupdate();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAppid();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getCreatetime();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDownloadurl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFilemd5();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.proto.Entity.LatestVersionInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.LatestVersionInfo} returns this
 */
proto.proto.Entity.LatestVersionInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 versionCode = 2;
 * @return {number}
 */
proto.proto.Entity.LatestVersionInfo.prototype.getVersioncode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.LatestVersionInfo} returns this
 */
proto.proto.Entity.LatestVersionInfo.prototype.setVersioncode = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 status = 3;
 * @return {number}
 */
proto.proto.Entity.LatestVersionInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.LatestVersionInfo} returns this
 */
proto.proto.Entity.LatestVersionInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool isForceUpdate = 4;
 * @return {boolean}
 */
proto.proto.Entity.LatestVersionInfo.prototype.getIsforceupdate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.LatestVersionInfo} returns this
 */
proto.proto.Entity.LatestVersionInfo.prototype.setIsforceupdate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional uint32 appid = 5;
 * @return {number}
 */
proto.proto.Entity.LatestVersionInfo.prototype.getAppid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.LatestVersionInfo} returns this
 */
proto.proto.Entity.LatestVersionInfo.prototype.setAppid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint64 createTime = 6;
 * @return {number}
 */
proto.proto.Entity.LatestVersionInfo.prototype.getCreatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.LatestVersionInfo} returns this
 */
proto.proto.Entity.LatestVersionInfo.prototype.setCreatetime = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string name = 7;
 * @return {string}
 */
proto.proto.Entity.LatestVersionInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LatestVersionInfo} returns this
 */
proto.proto.Entity.LatestVersionInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string version = 8;
 * @return {string}
 */
proto.proto.Entity.LatestVersionInfo.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LatestVersionInfo} returns this
 */
proto.proto.Entity.LatestVersionInfo.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string downloadUrl = 9;
 * @return {string}
 */
proto.proto.Entity.LatestVersionInfo.prototype.getDownloadurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LatestVersionInfo} returns this
 */
proto.proto.Entity.LatestVersionInfo.prototype.setDownloadurl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string fileMd5 = 10;
 * @return {string}
 */
proto.proto.Entity.LatestVersionInfo.prototype.getFilemd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LatestVersionInfo} returns this
 */
proto.proto.Entity.LatestVersionInfo.prototype.setFilemd5 = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string description = 11;
 * @return {string}
 */
proto.proto.Entity.LatestVersionInfo.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LatestVersionInfo} returns this
 */
proto.proto.Entity.LatestVersionInfo.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.SessionStateInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.SessionStateInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.SessionStateInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.SessionStateInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sessionsource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sessionstate: jspb.Message.getFieldWithDefault(msg, 3, 0),
    closereason: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.SessionStateInfo}
 */
proto.proto.Entity.SessionStateInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.SessionStateInfo;
  return proto.proto.Entity.SessionStateInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.SessionStateInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.SessionStateInfo}
 */
proto.proto.Entity.SessionStateInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSessionsource(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSessionstate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setClosereason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.SessionStateInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.SessionStateInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.SessionStateInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.SessionStateInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSessionsource();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getSessionstate();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getClosereason();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional string sessionId = 1;
 * @return {string}
 */
proto.proto.Entity.SessionStateInfo.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.SessionStateInfo} returns this
 */
proto.proto.Entity.SessionStateInfo.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 sessionSource = 2;
 * @return {number}
 */
proto.proto.Entity.SessionStateInfo.prototype.getSessionsource = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.SessionStateInfo} returns this
 */
proto.proto.Entity.SessionStateInfo.prototype.setSessionsource = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 sessionState = 3;
 * @return {number}
 */
proto.proto.Entity.SessionStateInfo.prototype.getSessionstate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.SessionStateInfo} returns this
 */
proto.proto.Entity.SessionStateInfo.prototype.setSessionstate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 closeReason = 4;
 * @return {number}
 */
proto.proto.Entity.SessionStateInfo.prototype.getClosereason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.SessionStateInfo} returns this
 */
proto.proto.Entity.SessionStateInfo.prototype.setClosereason = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ChannelUserStateInfo.repeatedFields_ = [18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ChannelUserStateInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ChannelUserStateInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelUserStateInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    hasphoto: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    isself: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    iscaller: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    avatarurl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    username: jspb.Message.getFieldWithDefault(msg, 5, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    corpid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    corpname: jspb.Message.getFieldWithDefault(msg, 8, ""),
    onlinestatus: jspb.Message.getFieldWithDefault(msg, 9, 0),
    sessionstate: jspb.Message.getFieldWithDefault(msg, 10, 0),
    statereason: jspb.Message.getFieldWithDefault(msg, 11, 0),
    devicetype: jspb.Message.getFieldWithDefault(msg, 12, 0),
    mediatype: jspb.Message.getFieldWithDefault(msg, 13, 0),
    ismicopen: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    isvideoopen: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    isspeakeropen: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    isrecordopen: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
    rolesList: (f = jspb.Message.getRepeatedField(msg, 18)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ChannelUserStateInfo}
 */
proto.proto.Entity.ChannelUserStateInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ChannelUserStateInfo;
  return proto.proto.Entity.ChannelUserStateInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ChannelUserStateInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ChannelUserStateInfo}
 */
proto.proto.Entity.ChannelUserStateInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasphoto(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsself(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscaller(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarurl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpname(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOnlinestatus(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSessionstate(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatereason(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDevicetype(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMediatype(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsmicopen(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsvideoopen(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsspeakeropen(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsrecordopen(value);
      break;
    case 18:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRoles(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ChannelUserStateInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ChannelUserStateInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelUserStateInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasphoto();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getIsself();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getIscaller();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getAvatarurl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCorpname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOnlinestatus();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getSessionstate();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getStatereason();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getDevicetype();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getMediatype();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
  f = message.getIsmicopen();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getIsvideoopen();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getIsspeakeropen();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getIsrecordopen();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writePackedUint32(
      18,
      f
    );
  }
};


/**
 * optional bool HasPhoto = 1;
 * @return {boolean}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getHasphoto = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setHasphoto = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool isSelf = 2;
 * @return {boolean}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getIsself = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setIsself = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool isCaller = 3;
 * @return {boolean}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getIscaller = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setIscaller = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string avatarUrl = 4;
 * @return {string}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getAvatarurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setAvatarurl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string userName = 5;
 * @return {string}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string userID = 6;
 * @return {string}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string corpId = 7;
 * @return {string}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string corpName = 8;
 * @return {string}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getCorpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setCorpname = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional uint32 onlineStatus = 9;
 * @return {number}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getOnlinestatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setOnlinestatus = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint32 sessionState = 10;
 * @return {number}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getSessionstate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setSessionstate = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional uint32 stateReason = 11;
 * @return {number}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getStatereason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setStatereason = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional uint32 deviceType = 12;
 * @return {number}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getDevicetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setDevicetype = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional uint32 mediaType = 13;
 * @return {number}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getMediatype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setMediatype = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional bool isMicOpen = 14;
 * @return {boolean}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getIsmicopen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setIsmicopen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool isVideoOpen = 15;
 * @return {boolean}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getIsvideoopen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setIsvideoopen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool isSpeakerOpen = 16;
 * @return {boolean}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getIsspeakeropen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setIsspeakeropen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional bool isRecordOpen = 17;
 * @return {boolean}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getIsrecordopen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setIsrecordopen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * repeated uint32 roles = 18;
 * @return {!Array<number>}
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.getRolesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 18));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.setRolesList = function(value) {
  return jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.addRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ChannelUserStateInfo} returns this
 */
proto.proto.Entity.ChannelUserStateInfo.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.SessionUserStateInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.SessionUserStateInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.SessionUserStateInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.SessionUserStateInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userinfo: (f = msg.getUserinfo()) && proto.proto.Entity.ChannelUserStateInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.SessionUserStateInfo}
 */
proto.proto.Entity.SessionUserStateInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.SessionUserStateInfo;
  return proto.proto.Entity.SessionUserStateInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.SessionUserStateInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.SessionUserStateInfo}
 */
proto.proto.Entity.SessionUserStateInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 2:
      var value = new proto.proto.Entity.ChannelUserStateInfo;
      reader.readMessage(value,proto.proto.Entity.ChannelUserStateInfo.deserializeBinaryFromReader);
      msg.setUserinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.SessionUserStateInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.SessionUserStateInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.SessionUserStateInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.SessionUserStateInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserinfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.Entity.ChannelUserStateInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string sessionId = 1;
 * @return {string}
 */
proto.proto.Entity.SessionUserStateInfo.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.SessionUserStateInfo} returns this
 */
proto.proto.Entity.SessionUserStateInfo.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ChannelUserStateInfo userInfo = 2;
 * @return {?proto.proto.Entity.ChannelUserStateInfo}
 */
proto.proto.Entity.SessionUserStateInfo.prototype.getUserinfo = function() {
  return /** @type{?proto.proto.Entity.ChannelUserStateInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.ChannelUserStateInfo, 2));
};


/**
 * @param {?proto.proto.Entity.ChannelUserStateInfo|undefined} value
 * @return {!proto.proto.Entity.SessionUserStateInfo} returns this
*/
proto.proto.Entity.SessionUserStateInfo.prototype.setUserinfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.SessionUserStateInfo} returns this
 */
proto.proto.Entity.SessionUserStateInfo.prototype.clearUserinfo = function() {
  return this.setUserinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.SessionUserStateInfo.prototype.hasUserinfo = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ChannelUserData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ChannelUserData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ChannelUserData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ChannelUserData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelUserData.toObject = function(includeInstance, msg) {
  var f, obj = {
    channeluserarrayList: jspb.Message.toObjectList(msg.getChanneluserarrayList(),
    proto.proto.Entity.ChannelUserStateInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ChannelUserData}
 */
proto.proto.Entity.ChannelUserData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ChannelUserData;
  return proto.proto.Entity.ChannelUserData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ChannelUserData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ChannelUserData}
 */
proto.proto.Entity.ChannelUserData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.ChannelUserStateInfo;
      reader.readMessage(value,proto.proto.Entity.ChannelUserStateInfo.deserializeBinaryFromReader);
      msg.addChanneluserarray(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ChannelUserData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ChannelUserData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ChannelUserData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelUserData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChanneluserarrayList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.ChannelUserStateInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ChannelUserStateInfo channelUserArray = 1;
 * @return {!Array<!proto.proto.Entity.ChannelUserStateInfo>}
 */
proto.proto.Entity.ChannelUserData.prototype.getChanneluserarrayList = function() {
  return /** @type{!Array<!proto.proto.Entity.ChannelUserStateInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.ChannelUserStateInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.ChannelUserStateInfo>} value
 * @return {!proto.proto.Entity.ChannelUserData} returns this
*/
proto.proto.Entity.ChannelUserData.prototype.setChanneluserarrayList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.ChannelUserStateInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ChannelUserStateInfo}
 */
proto.proto.Entity.ChannelUserData.prototype.addChanneluserarray = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.ChannelUserStateInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ChannelUserData} returns this
 */
proto.proto.Entity.ChannelUserData.prototype.clearChanneluserarrayList = function() {
  return this.setChanneluserarrayList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.LiveStreamUrlResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.LiveStreamUrlResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.LiveStreamUrlResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.LiveStreamUrlResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    corpid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    channeld: jspb.Message.getFieldWithDefault(msg, 3, ""),
    streamid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    rtmpurl: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.LiveStreamUrlResponse}
 */
proto.proto.Entity.LiveStreamUrlResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.LiveStreamUrlResponse;
  return proto.proto.Entity.LiveStreamUrlResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.LiveStreamUrlResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.LiveStreamUrlResponse}
 */
proto.proto.Entity.LiveStreamUrlResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChanneld(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreamid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRtmpurl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.LiveStreamUrlResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.LiveStreamUrlResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.LiveStreamUrlResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.LiveStreamUrlResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChanneld();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStreamid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRtmpurl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string userId = 1;
 * @return {string}
 */
proto.proto.Entity.LiveStreamUrlResponse.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamUrlResponse} returns this
 */
proto.proto.Entity.LiveStreamUrlResponse.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string corpId = 2;
 * @return {string}
 */
proto.proto.Entity.LiveStreamUrlResponse.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamUrlResponse} returns this
 */
proto.proto.Entity.LiveStreamUrlResponse.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string channeld = 3;
 * @return {string}
 */
proto.proto.Entity.LiveStreamUrlResponse.prototype.getChanneld = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamUrlResponse} returns this
 */
proto.proto.Entity.LiveStreamUrlResponse.prototype.setChanneld = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string streamId = 4;
 * @return {string}
 */
proto.proto.Entity.LiveStreamUrlResponse.prototype.getStreamid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamUrlResponse} returns this
 */
proto.proto.Entity.LiveStreamUrlResponse.prototype.setStreamid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string rtmpUrl = 5;
 * @return {string}
 */
proto.proto.Entity.LiveStreamUrlResponse.prototype.getRtmpurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamUrlResponse} returns this
 */
proto.proto.Entity.LiveStreamUrlResponse.prototype.setRtmpurl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.LiveStreamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.LiveStreamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.LiveStreamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.LiveStreamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    streamid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.LiveStreamResponse}
 */
proto.proto.Entity.LiveStreamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.LiveStreamResponse;
  return proto.proto.Entity.LiveStreamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.LiveStreamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.LiveStreamResponse}
 */
proto.proto.Entity.LiveStreamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreamid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.LiveStreamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.LiveStreamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.LiveStreamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.LiveStreamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStreamid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string userId = 1;
 * @return {string}
 */
proto.proto.Entity.LiveStreamResponse.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamResponse} returns this
 */
proto.proto.Entity.LiveStreamResponse.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string streamId = 2;
 * @return {string}
 */
proto.proto.Entity.LiveStreamResponse.prototype.getStreamid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamResponse} returns this
 */
proto.proto.Entity.LiveStreamResponse.prototype.setStreamid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.LiveStreamCtrlInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.LiveStreamCtrlInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.LiveStreamCtrlInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    streamid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    corpid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    channelid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    rtmpurl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    storeurl: jspb.Message.getFieldWithDefault(msg, 6, ""),
    remark: jspb.Message.getFieldWithDefault(msg, 7, ""),
    assigntimestamp: jspb.Message.getFieldWithDefault(msg, 8, 0),
    starttimestamp: jspb.Message.getFieldWithDefault(msg, 9, 0),
    stoptimestamp: jspb.Message.getFieldWithDefault(msg, 10, 0),
    stopreason: jspb.Message.getFieldWithDefault(msg, 11, 0),
    status: jspb.Message.getFieldWithDefault(msg, 12, 0),
    coverurl: jspb.Message.getFieldWithDefault(msg, 13, ""),
    flvurl: jspb.Message.getFieldWithDefault(msg, 14, ""),
    m3u8url: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo}
 */
proto.proto.Entity.LiveStreamCtrlInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.LiveStreamCtrlInfo;
  return proto.proto.Entity.LiveStreamCtrlInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.LiveStreamCtrlInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo}
 */
proto.proto.Entity.LiveStreamCtrlInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreamid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRtmpurl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStoreurl(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAssigntimestamp(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setStarttimestamp(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setStoptimestamp(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStopreason(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoverurl(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlvurl(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setM3u8url(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.LiveStreamCtrlInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.LiveStreamCtrlInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.LiveStreamCtrlInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStreamid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChannelid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRtmpurl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStoreurl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAssigntimestamp();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getStarttimestamp();
  if (f !== 0) {
    writer.writeUint64(
      9,
      f
    );
  }
  f = message.getStoptimestamp();
  if (f !== 0) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = message.getStopreason();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getCoverurl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getFlvurl();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getM3u8url();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional string streamId = 1;
 * @return {string}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getStreamid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setStreamid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string userId = 2;
 * @return {string}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string corpId = 3;
 * @return {string}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string channelId = 4;
 * @return {string}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getChannelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setChannelid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string rtmpUrl = 5;
 * @return {string}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getRtmpurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setRtmpurl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string storeUrl = 6;
 * @return {string}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getStoreurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setStoreurl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string remark = 7;
 * @return {string}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setRemark = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint64 assignTimeStamp = 8;
 * @return {number}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getAssigntimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setAssigntimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint64 startTimeStamp = 9;
 * @return {number}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getStarttimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setStarttimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint64 stopTimeStamp = 10;
 * @return {number}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getStoptimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setStoptimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional uint32 stopReason = 11;
 * @return {number}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getStopreason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setStopreason = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional uint32 status = 12;
 * @return {number}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string coverUrl = 13;
 * @return {string}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getCoverurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setCoverurl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string flvUrl = 14;
 * @return {string}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getFlvurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setFlvurl = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string m3u8Url = 15;
 * @return {string}
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.getM3u8url = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.LiveStreamCtrlInfo} returns this
 */
proto.proto.Entity.LiveStreamCtrlInfo.prototype.setM3u8url = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.EnableLiveStreamData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.EnableLiveStreamData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.EnableLiveStreamData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.EnableLiveStreamData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.EnableLiveStreamData.toObject = function(includeInstance, msg) {
  var f, obj = {
    useridlistList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.EnableLiveStreamData}
 */
proto.proto.Entity.EnableLiveStreamData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.EnableLiveStreamData;
  return proto.proto.Entity.EnableLiveStreamData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.EnableLiveStreamData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.EnableLiveStreamData}
 */
proto.proto.Entity.EnableLiveStreamData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUseridlist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.EnableLiveStreamData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.EnableLiveStreamData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.EnableLiveStreamData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.EnableLiveStreamData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUseridlistList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string userIdList = 1;
 * @return {!Array<string>}
 */
proto.proto.Entity.EnableLiveStreamData.prototype.getUseridlistList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.EnableLiveStreamData} returns this
 */
proto.proto.Entity.EnableLiveStreamData.prototype.setUseridlistList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.EnableLiveStreamData} returns this
 */
proto.proto.Entity.EnableLiveStreamData.prototype.addUseridlist = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.EnableLiveStreamData} returns this
 */
proto.proto.Entity.EnableLiveStreamData.prototype.clearUseridlistList = function() {
  return this.setUseridlistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.Error.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.Error.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.Error} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.Error.toObject = function(includeInstance, msg) {
  var f, obj = {
    errcode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    errmsg: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.Error}
 */
proto.proto.Entity.Error.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.Error;
  return proto.proto.Entity.Error.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.Error} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.Error}
 */
proto.proto.Entity.Error.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setErrcode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrmsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.Error.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.Error.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.Error} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.Error.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErrcode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getErrmsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 errCode = 1;
 * @return {number}
 */
proto.proto.Entity.Error.prototype.getErrcode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.Error} returns this
 */
proto.proto.Entity.Error.prototype.setErrcode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string errMsg = 2;
 * @return {string}
 */
proto.proto.Entity.Error.prototype.getErrmsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.Error} returns this
 */
proto.proto.Entity.Error.prototype.setErrmsg = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ChatMsgInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ChatMsgInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ChatMsgInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChatMsgInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    timestamp: jspb.Message.getFieldWithDefault(msg, 1, 0),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isgroupmsg: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    uniquekey: jspb.Message.getFieldWithDefault(msg, 5, 0),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0),
    userid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    username: jspb.Message.getFieldWithDefault(msg, 8, ""),
    text: jspb.Message.getFieldWithDefault(msg, 9, ""),
    url: jspb.Message.getFieldWithDefault(msg, 10, ""),
    path: jspb.Message.getFieldWithDefault(msg, 11, ""),
    filename: jspb.Message.getFieldWithDefault(msg, 12, ""),
    filesize: jspb.Message.getFieldWithDefault(msg, 13, 0),
    medialenght: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
    calldealtype: jspb.Message.getFieldWithDefault(msg, 15, 0),
    calltime: jspb.Message.getFieldWithDefault(msg, 16, 0),
    callmembers: jspb.Message.getFieldWithDefault(msg, 17, ""),
    creatorid: jspb.Message.getFieldWithDefault(msg, 18, ""),
    inviterid: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ChatMsgInfo}
 */
proto.proto.Entity.ChatMsgInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ChatMsgInfo;
  return proto.proto.Entity.ChatMsgInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ChatMsgInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ChatMsgInfo}
 */
proto.proto.Entity.ChatMsgInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsgroupmsg(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUniquekey(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFilesize(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMedialenght(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCalldealtype(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCalltime(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCallmembers(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatorid(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviterid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ChatMsgInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ChatMsgInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ChatMsgInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChatMsgInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsgroupmsg();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getUniquekey();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getFilesize();
  if (f !== 0) {
    writer.writeUint64(
      13,
      f
    );
  }
  f = message.getMedialenght();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getCalldealtype();
  if (f !== 0) {
    writer.writeUint32(
      15,
      f
    );
  }
  f = message.getCalltime();
  if (f !== 0) {
    writer.writeUint64(
      16,
      f
    );
  }
  f = message.getCallmembers();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getCreatorid();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getInviterid();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional uint64 timestamp = 1;
 * @return {number}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool isGroupMsg = 3;
 * @return {boolean}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getIsgroupmsg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setIsgroupmsg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional uint32 type = 4;
 * @return {number}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 uniqueKey = 5;
 * @return {number}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getUniquekey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setUniquekey = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 status = 6;
 * @return {number}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string userId = 7;
 * @return {string}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string userName = 8;
 * @return {string}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string text = 9;
 * @return {string}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string url = 10;
 * @return {string}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string path = 11;
 * @return {string}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string fileName = 12;
 * @return {string}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional uint64 fileSize = 13;
 * @return {number}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getFilesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setFilesize = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional double mediaLenght = 14;
 * @return {number}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getMedialenght = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setMedialenght = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional uint32 callDealType = 15;
 * @return {number}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getCalldealtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setCalldealtype = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional uint64 callTime = 16;
 * @return {number}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getCalltime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setCalltime = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string callMembers = 17;
 * @return {string}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getCallmembers = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setCallmembers = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string creatorId = 18;
 * @return {string}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getCreatorid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setCreatorid = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string inviterId = 19;
 * @return {string}
 */
proto.proto.Entity.ChatMsgInfo.prototype.getInviterid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChatMsgInfo} returns this
 */
proto.proto.Entity.ChatMsgInfo.prototype.setInviterid = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ChannelMsgInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ChannelMsgInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelMsgInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    channelid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    groupid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    uniquekey: jspb.Message.getFieldWithDefault(msg, 4, 0),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    type: jspb.Message.getFieldWithDefault(msg, 6, 0),
    username: jspb.Message.getFieldWithDefault(msg, 7, ""),
    text: jspb.Message.getFieldWithDefault(msg, 8, ""),
    url: jspb.Message.getFieldWithDefault(msg, 9, ""),
    filename: jspb.Message.getFieldWithDefault(msg, 10, ""),
    localpath: jspb.Message.getFieldWithDefault(msg, 11, ""),
    filesize: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ChannelMsgInfo}
 */
proto.proto.Entity.ChannelMsgInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ChannelMsgInfo;
  return proto.proto.Entity.ChannelMsgInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ChannelMsgInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ChannelMsgInfo}
 */
proto.proto.Entity.ChannelMsgInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUniquekey(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocalpath(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFilesize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ChannelMsgInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ChannelMsgInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelMsgInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroupid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUniquekey();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLocalpath();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFilesize();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
};


/**
 * optional string channelID = 1;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.getChannelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgInfo} returns this
 */
proto.proto.Entity.ChannelMsgInfo.prototype.setChannelid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string userID = 2;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgInfo} returns this
 */
proto.proto.Entity.ChannelMsgInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string groupID = 3;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.getGroupid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgInfo} returns this
 */
proto.proto.Entity.ChannelMsgInfo.prototype.setGroupid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 uniqueKey = 4;
 * @return {number}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.getUniquekey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelMsgInfo} returns this
 */
proto.proto.Entity.ChannelMsgInfo.prototype.setUniquekey = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 status = 5;
 * @return {number}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelMsgInfo} returns this
 */
proto.proto.Entity.ChannelMsgInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 type = 6;
 * @return {number}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelMsgInfo} returns this
 */
proto.proto.Entity.ChannelMsgInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string userName = 7;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgInfo} returns this
 */
proto.proto.Entity.ChannelMsgInfo.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string text = 8;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgInfo} returns this
 */
proto.proto.Entity.ChannelMsgInfo.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string url = 9;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgInfo} returns this
 */
proto.proto.Entity.ChannelMsgInfo.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string fileName = 10;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgInfo} returns this
 */
proto.proto.Entity.ChannelMsgInfo.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string localPath = 11;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.getLocalpath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgInfo} returns this
 */
proto.proto.Entity.ChannelMsgInfo.prototype.setLocalpath = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional uint64 fileSize = 12;
 * @return {number}
 */
proto.proto.Entity.ChannelMsgInfo.prototype.getFilesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelMsgInfo} returns this
 */
proto.proto.Entity.ChannelMsgInfo.prototype.setFilesize = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ChatMsgData.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ChatMsgData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ChatMsgData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ChatMsgData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChatMsgData.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    msgsList: jspb.Message.toObjectList(msg.getMsgsList(),
    proto.proto.Entity.ChatMsgInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ChatMsgData}
 */
proto.proto.Entity.ChatMsgData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ChatMsgData;
  return proto.proto.Entity.ChatMsgData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ChatMsgData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ChatMsgData}
 */
proto.proto.Entity.ChatMsgData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.proto.Entity.ChatMsgInfo;
      reader.readMessage(value,proto.proto.Entity.ChatMsgInfo.deserializeBinaryFromReader);
      msg.addMsgs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ChatMsgData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ChatMsgData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ChatMsgData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChatMsgData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMsgsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.proto.Entity.ChatMsgInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.proto.Entity.ChatMsgData.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChatMsgData} returns this
 */
proto.proto.Entity.ChatMsgData.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ChatMsgInfo msgs = 2;
 * @return {!Array<!proto.proto.Entity.ChatMsgInfo>}
 */
proto.proto.Entity.ChatMsgData.prototype.getMsgsList = function() {
  return /** @type{!Array<!proto.proto.Entity.ChatMsgInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.ChatMsgInfo, 2));
};


/**
 * @param {!Array<!proto.proto.Entity.ChatMsgInfo>} value
 * @return {!proto.proto.Entity.ChatMsgData} returns this
*/
proto.proto.Entity.ChatMsgData.prototype.setMsgsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.proto.Entity.ChatMsgInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ChatMsgInfo}
 */
proto.proto.Entity.ChatMsgData.prototype.addMsgs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.proto.Entity.ChatMsgInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ChatMsgData} returns this
 */
proto.proto.Entity.ChatMsgData.prototype.clearMsgsList = function() {
  return this.setMsgsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.GroupMemberInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.GroupMemberInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.GroupMemberInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.GroupMemberInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    memberid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    corpid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    avatarurl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    jointime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    nick: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.GroupMemberInfo}
 */
proto.proto.Entity.GroupMemberInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.GroupMemberInfo;
  return proto.proto.Entity.GroupMemberInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.GroupMemberInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.GroupMemberInfo}
 */
proto.proto.Entity.GroupMemberInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarurl(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setJointime(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNick(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.GroupMemberInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.GroupMemberInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.GroupMemberInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.GroupMemberInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMemberid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAvatarurl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getJointime();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getNick();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string memberId = 1;
 * @return {string}
 */
proto.proto.Entity.GroupMemberInfo.prototype.getMemberid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.GroupMemberInfo} returns this
 */
proto.proto.Entity.GroupMemberInfo.prototype.setMemberid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string corpId = 2;
 * @return {string}
 */
proto.proto.Entity.GroupMemberInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.GroupMemberInfo} returns this
 */
proto.proto.Entity.GroupMemberInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.proto.Entity.GroupMemberInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.GroupMemberInfo} returns this
 */
proto.proto.Entity.GroupMemberInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string avatarUrl = 4;
 * @return {string}
 */
proto.proto.Entity.GroupMemberInfo.prototype.getAvatarurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.GroupMemberInfo} returns this
 */
proto.proto.Entity.GroupMemberInfo.prototype.setAvatarurl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 joinTime = 5;
 * @return {number}
 */
proto.proto.Entity.GroupMemberInfo.prototype.getJointime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.GroupMemberInfo} returns this
 */
proto.proto.Entity.GroupMemberInfo.prototype.setJointime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string nick = 6;
 * @return {string}
 */
proto.proto.Entity.GroupMemberInfo.prototype.getNick = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.GroupMemberInfo} returns this
 */
proto.proto.Entity.GroupMemberInfo.prototype.setNick = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.GroupInfo.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.GroupInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.GroupInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.GroupInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.GroupInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    createtime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    lasttime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    ownerid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    type: jspb.Message.getFieldWithDefault(msg, 6, 0),
    status: jspb.Message.getFieldWithDefault(msg, 7, 0),
    groupspell: jspb.Message.getFieldWithDefault(msg, 8, ""),
    memberList: jspb.Message.toObjectList(msg.getMemberList(),
    proto.proto.Entity.GroupMemberInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.GroupInfo}
 */
proto.proto.Entity.GroupInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.GroupInfo;
  return proto.proto.Entity.GroupInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.GroupInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.GroupInfo}
 */
proto.proto.Entity.GroupInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCreatetime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLasttime(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupspell(value);
      break;
    case 10:
      var value = new proto.proto.Entity.GroupMemberInfo;
      reader.readMessage(value,proto.proto.Entity.GroupMemberInfo.deserializeBinaryFromReader);
      msg.addMember(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.GroupInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.GroupInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.GroupInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.GroupInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatetime();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getLasttime();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getOwnerid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getGroupspell();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMemberList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.proto.Entity.GroupMemberInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string groupId = 1;
 * @return {string}
 */
proto.proto.Entity.GroupInfo.prototype.getGroupid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.GroupInfo} returns this
 */
proto.proto.Entity.GroupInfo.prototype.setGroupid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.proto.Entity.GroupInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.GroupInfo} returns this
 */
proto.proto.Entity.GroupInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 createTime = 3;
 * @return {number}
 */
proto.proto.Entity.GroupInfo.prototype.getCreatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.GroupInfo} returns this
 */
proto.proto.Entity.GroupInfo.prototype.setCreatetime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 lastTime = 4;
 * @return {number}
 */
proto.proto.Entity.GroupInfo.prototype.getLasttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.GroupInfo} returns this
 */
proto.proto.Entity.GroupInfo.prototype.setLasttime = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string ownerID = 5;
 * @return {string}
 */
proto.proto.Entity.GroupInfo.prototype.getOwnerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.GroupInfo} returns this
 */
proto.proto.Entity.GroupInfo.prototype.setOwnerid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 type = 6;
 * @return {number}
 */
proto.proto.Entity.GroupInfo.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.GroupInfo} returns this
 */
proto.proto.Entity.GroupInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 status = 7;
 * @return {number}
 */
proto.proto.Entity.GroupInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.GroupInfo} returns this
 */
proto.proto.Entity.GroupInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string groupSpell = 8;
 * @return {string}
 */
proto.proto.Entity.GroupInfo.prototype.getGroupspell = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.GroupInfo} returns this
 */
proto.proto.Entity.GroupInfo.prototype.setGroupspell = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated GroupMemberInfo member = 10;
 * @return {!Array<!proto.proto.Entity.GroupMemberInfo>}
 */
proto.proto.Entity.GroupInfo.prototype.getMemberList = function() {
  return /** @type{!Array<!proto.proto.Entity.GroupMemberInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.GroupMemberInfo, 10));
};


/**
 * @param {!Array<!proto.proto.Entity.GroupMemberInfo>} value
 * @return {!proto.proto.Entity.GroupInfo} returns this
*/
proto.proto.Entity.GroupInfo.prototype.setMemberList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.proto.Entity.GroupMemberInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.GroupMemberInfo}
 */
proto.proto.Entity.GroupInfo.prototype.addMember = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.proto.Entity.GroupMemberInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.GroupInfo} returns this
 */
proto.proto.Entity.GroupInfo.prototype.clearMemberList = function() {
  return this.setMemberList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.GroupList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.GroupList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.GroupList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.GroupList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.GroupList.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.proto.Entity.GroupInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.GroupList}
 */
proto.proto.Entity.GroupList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.GroupList;
  return proto.proto.Entity.GroupList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.GroupList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.GroupList}
 */
proto.proto.Entity.GroupList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.GroupInfo;
      reader.readMessage(value,proto.proto.Entity.GroupInfo.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.GroupList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.GroupList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.GroupList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.GroupList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.GroupInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated GroupInfo list = 1;
 * @return {!Array<!proto.proto.Entity.GroupInfo>}
 */
proto.proto.Entity.GroupList.prototype.getListList = function() {
  return /** @type{!Array<!proto.proto.Entity.GroupInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.GroupInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.GroupInfo>} value
 * @return {!proto.proto.Entity.GroupList} returns this
*/
proto.proto.Entity.GroupList.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.GroupInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.GroupInfo}
 */
proto.proto.Entity.GroupList.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.GroupInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.GroupList} returns this
 */
proto.proto.Entity.GroupList.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.RecentContactInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.RecentContactInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.RecentContactInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.RecentContactInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    rcid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rcname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rctype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    msg: (f = msg.getMsg()) && proto.proto.Entity.ChatMsgInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.RecentContactInfo}
 */
proto.proto.Entity.RecentContactInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.RecentContactInfo;
  return proto.proto.Entity.RecentContactInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.RecentContactInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.RecentContactInfo}
 */
proto.proto.Entity.RecentContactInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRcid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRcname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRctype(value);
      break;
    case 4:
      var value = new proto.proto.Entity.ChatMsgInfo;
      reader.readMessage(value,proto.proto.Entity.ChatMsgInfo.deserializeBinaryFromReader);
      msg.setMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.RecentContactInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.RecentContactInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.RecentContactInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.RecentContactInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRcid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRcname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRctype();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getMsg();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.proto.Entity.ChatMsgInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string rcid = 1;
 * @return {string}
 */
proto.proto.Entity.RecentContactInfo.prototype.getRcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.RecentContactInfo} returns this
 */
proto.proto.Entity.RecentContactInfo.prototype.setRcid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string rcname = 2;
 * @return {string}
 */
proto.proto.Entity.RecentContactInfo.prototype.getRcname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.RecentContactInfo} returns this
 */
proto.proto.Entity.RecentContactInfo.prototype.setRcname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 rctype = 3;
 * @return {number}
 */
proto.proto.Entity.RecentContactInfo.prototype.getRctype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.RecentContactInfo} returns this
 */
proto.proto.Entity.RecentContactInfo.prototype.setRctype = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ChatMsgInfo msg = 4;
 * @return {?proto.proto.Entity.ChatMsgInfo}
 */
proto.proto.Entity.RecentContactInfo.prototype.getMsg = function() {
  return /** @type{?proto.proto.Entity.ChatMsgInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.ChatMsgInfo, 4));
};


/**
 * @param {?proto.proto.Entity.ChatMsgInfo|undefined} value
 * @return {!proto.proto.Entity.RecentContactInfo} returns this
*/
proto.proto.Entity.RecentContactInfo.prototype.setMsg = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.RecentContactInfo} returns this
 */
proto.proto.Entity.RecentContactInfo.prototype.clearMsg = function() {
  return this.setMsg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.RecentContactInfo.prototype.hasMsg = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.RecentContactList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.RecentContactList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.RecentContactList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.RecentContactList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.RecentContactList.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.proto.Entity.RecentContactInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.RecentContactList}
 */
proto.proto.Entity.RecentContactList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.RecentContactList;
  return proto.proto.Entity.RecentContactList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.RecentContactList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.RecentContactList}
 */
proto.proto.Entity.RecentContactList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.RecentContactInfo;
      reader.readMessage(value,proto.proto.Entity.RecentContactInfo.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.RecentContactList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.RecentContactList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.RecentContactList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.RecentContactList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.RecentContactInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated RecentContactInfo list = 1;
 * @return {!Array<!proto.proto.Entity.RecentContactInfo>}
 */
proto.proto.Entity.RecentContactList.prototype.getListList = function() {
  return /** @type{!Array<!proto.proto.Entity.RecentContactInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.RecentContactInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.RecentContactInfo>} value
 * @return {!proto.proto.Entity.RecentContactList} returns this
*/
proto.proto.Entity.RecentContactList.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.RecentContactInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.RecentContactInfo}
 */
proto.proto.Entity.RecentContactList.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.RecentContactInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.RecentContactList} returns this
 */
proto.proto.Entity.RecentContactList.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ChannelCooperationInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ChannelCooperationInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelCooperationInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ownerid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    bectrlid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ownerurl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    receiverurl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    channelid: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ChannelCooperationInfo}
 */
proto.proto.Entity.ChannelCooperationInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ChannelCooperationInfo;
  return proto.proto.Entity.ChannelCooperationInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ChannelCooperationInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ChannelCooperationInfo}
 */
proto.proto.Entity.ChannelCooperationInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.Entity.CooperationType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBectrlid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerurl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiverurl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ChannelCooperationInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ChannelCooperationInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelCooperationInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getOwnerid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBectrlid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOwnerurl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getReceiverurl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getChannelid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional CooperationType type = 1;
 * @return {!proto.proto.Entity.CooperationType}
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.getType = function() {
  return /** @type {!proto.proto.Entity.CooperationType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.proto.Entity.CooperationType} value
 * @return {!proto.proto.Entity.ChannelCooperationInfo} returns this
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string ownerId = 2;
 * @return {string}
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.getOwnerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelCooperationInfo} returns this
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.setOwnerid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string beCtrlId = 3;
 * @return {string}
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.getBectrlid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelCooperationInfo} returns this
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.setBectrlid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ownerUrl = 4;
 * @return {string}
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.getOwnerurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelCooperationInfo} returns this
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.setOwnerurl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string receiverUrl = 5;
 * @return {string}
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.getReceiverurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelCooperationInfo} returns this
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.setReceiverurl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string channelId = 6;
 * @return {string}
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.getChannelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelCooperationInfo} returns this
 */
proto.proto.Entity.ChannelCooperationInfo.prototype.setChannelid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ChannelMsgSendReq.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ChannelMsgSendReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ChannelMsgSendReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelMsgSendReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    channelid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    groupid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    serialnum: jspb.Message.getFieldWithDefault(msg, 4, 0),
    content: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ChannelMsgSendReq}
 */
proto.proto.Entity.ChannelMsgSendReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ChannelMsgSendReq;
  return proto.proto.Entity.ChannelMsgSendReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ChannelMsgSendReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ChannelMsgSendReq}
 */
proto.proto.Entity.ChannelMsgSendReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSerialnum(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ChannelMsgSendReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ChannelMsgSendReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ChannelMsgSendReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelMsgSendReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroupid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSerialnum();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string ChannelID = 1;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgSendReq.prototype.getChannelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgSendReq} returns this
 */
proto.proto.Entity.ChannelMsgSendReq.prototype.setChannelid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string UserID = 2;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgSendReq.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgSendReq} returns this
 */
proto.proto.Entity.ChannelMsgSendReq.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string GroupID = 3;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgSendReq.prototype.getGroupid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgSendReq} returns this
 */
proto.proto.Entity.ChannelMsgSendReq.prototype.setGroupid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 SerialNum = 4;
 * @return {number}
 */
proto.proto.Entity.ChannelMsgSendReq.prototype.getSerialnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelMsgSendReq} returns this
 */
proto.proto.Entity.ChannelMsgSendReq.prototype.setSerialnum = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string Content = 5;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgSendReq.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgSendReq} returns this
 */
proto.proto.Entity.ChannelMsgSendReq.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ChannelMsgRelayNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ChannelMsgRelayNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelMsgRelayNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    channelid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    groupid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    serialnum: jspb.Message.getFieldWithDefault(msg, 4, 0),
    msgtimestamp: jspb.Message.getFieldWithDefault(msg, 5, 0),
    content: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ChannelMsgRelayNty}
 */
proto.proto.Entity.ChannelMsgRelayNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ChannelMsgRelayNty;
  return proto.proto.Entity.ChannelMsgRelayNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ChannelMsgRelayNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ChannelMsgRelayNty}
 */
proto.proto.Entity.ChannelMsgRelayNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSerialnum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMsgtimestamp(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ChannelMsgRelayNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ChannelMsgRelayNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelMsgRelayNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroupid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSerialnum();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getMsgtimestamp();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string ChannelID = 1;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.getChannelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgRelayNty} returns this
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.setChannelid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string UserID = 2;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgRelayNty} returns this
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string GroupID = 3;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.getGroupid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgRelayNty} returns this
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.setGroupid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 SerialNum = 4;
 * @return {number}
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.getSerialnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelMsgRelayNty} returns this
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.setSerialnum = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint64 MsgTimestamp = 5;
 * @return {number}
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.getMsgtimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelMsgRelayNty} returns this
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.setMsgtimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string Content = 6;
 * @return {string}
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelMsgRelayNty} returns this
 */
proto.proto.Entity.ChannelMsgRelayNty.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.SyncCCtrlReq.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.SyncCCtrlReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.SyncCCtrlReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.SyncCCtrlReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    channelid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    groupid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.SyncCCtrlReq}
 */
proto.proto.Entity.SyncCCtrlReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.SyncCCtrlReq;
  return proto.proto.Entity.SyncCCtrlReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.SyncCCtrlReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.SyncCCtrlReq}
 */
proto.proto.Entity.SyncCCtrlReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.SyncCCtrlReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.SyncCCtrlReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.SyncCCtrlReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.SyncCCtrlReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string ChannelID = 1;
 * @return {string}
 */
proto.proto.Entity.SyncCCtrlReq.prototype.getChannelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.SyncCCtrlReq} returns this
 */
proto.proto.Entity.SyncCCtrlReq.prototype.setChannelid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string GroupID = 2;
 * @return {string}
 */
proto.proto.Entity.SyncCCtrlReq.prototype.getGroupid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.SyncCCtrlReq} returns this
 */
proto.proto.Entity.SyncCCtrlReq.prototype.setGroupid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.OrganizationStreamInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.OrganizationStreamInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.OrganizationStreamInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    corpid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    channelid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    streamid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    coverurl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    rtmpurl: jspb.Message.getFieldWithDefault(msg, 6, ""),
    storeurl: jspb.Message.getFieldWithDefault(msg, 7, ""),
    flvurl: jspb.Message.getFieldWithDefault(msg, 8, ""),
    m3u8url: jspb.Message.getFieldWithDefault(msg, 9, ""),
    status: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.OrganizationStreamInfo}
 */
proto.proto.Entity.OrganizationStreamInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.OrganizationStreamInfo;
  return proto.proto.Entity.OrganizationStreamInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.OrganizationStreamInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.OrganizationStreamInfo}
 */
proto.proto.Entity.OrganizationStreamInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreamid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoverurl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRtmpurl(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStoreurl(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFlvurl(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setM3u8url(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.OrganizationStreamInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.OrganizationStreamInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.OrganizationStreamInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChannelid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStreamid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCoverurl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRtmpurl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStoreurl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFlvurl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getM3u8url();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
};


/**
 * optional string userId = 1;
 * @return {string}
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.OrganizationStreamInfo} returns this
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string corpId = 2;
 * @return {string}
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.OrganizationStreamInfo} returns this
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string channelId = 3;
 * @return {string}
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.getChannelid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.OrganizationStreamInfo} returns this
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.setChannelid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string streamId = 4;
 * @return {string}
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.getStreamid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.OrganizationStreamInfo} returns this
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.setStreamid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string coverUrl = 5;
 * @return {string}
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.getCoverurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.OrganizationStreamInfo} returns this
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.setCoverurl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string rtmpURL = 6;
 * @return {string}
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.getRtmpurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.OrganizationStreamInfo} returns this
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.setRtmpurl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string storeURL = 7;
 * @return {string}
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.getStoreurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.OrganizationStreamInfo} returns this
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.setStoreurl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string flvURL = 8;
 * @return {string}
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.getFlvurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.OrganizationStreamInfo} returns this
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.setFlvurl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string m3u8URL = 9;
 * @return {string}
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.getM3u8url = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.OrganizationStreamInfo} returns this
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.setM3u8url = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional uint32 status = 10;
 * @return {number}
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.OrganizationStreamInfo} returns this
 */
proto.proto.Entity.OrganizationStreamInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ChannelInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ChannelInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ChannelInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 2, 0),
    channelname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    srcid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    creatorid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    creatorname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    createtimestamp: jspb.Message.getFieldWithDefault(msg, 7, 0),
    closetimestamp: jspb.Message.getFieldWithDefault(msg, 8, 0),
    isalive: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    sessionsource: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ChannelInfo}
 */
proto.proto.Entity.ChannelInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ChannelInfo;
  return proto.proto.Entity.ChannelInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ChannelInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ChannelInfo}
 */
proto.proto.Entity.ChannelInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannelname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatorid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatorname(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCreatetimestamp(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setClosetimestamp(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsalive(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSessionsource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ChannelInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ChannelInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ChannelInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getChannelname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatorid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatorname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatetimestamp();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getClosetimestamp();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getIsalive();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getSessionsource();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
};


/**
 * optional string roomId = 1;
 * @return {string}
 */
proto.proto.Entity.ChannelInfo.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelInfo} returns this
 */
proto.proto.Entity.ChannelInfo.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 roomKey = 2;
 * @return {number}
 */
proto.proto.Entity.ChannelInfo.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelInfo} returns this
 */
proto.proto.Entity.ChannelInfo.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string channelName = 3;
 * @return {string}
 */
proto.proto.Entity.ChannelInfo.prototype.getChannelname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelInfo} returns this
 */
proto.proto.Entity.ChannelInfo.prototype.setChannelname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string srcId = 4;
 * @return {string}
 */
proto.proto.Entity.ChannelInfo.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelInfo} returns this
 */
proto.proto.Entity.ChannelInfo.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string creatorId = 5;
 * @return {string}
 */
proto.proto.Entity.ChannelInfo.prototype.getCreatorid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelInfo} returns this
 */
proto.proto.Entity.ChannelInfo.prototype.setCreatorid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string creatorName = 6;
 * @return {string}
 */
proto.proto.Entity.ChannelInfo.prototype.getCreatorname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ChannelInfo} returns this
 */
proto.proto.Entity.ChannelInfo.prototype.setCreatorname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint64 createTimestamp = 7;
 * @return {number}
 */
proto.proto.Entity.ChannelInfo.prototype.getCreatetimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelInfo} returns this
 */
proto.proto.Entity.ChannelInfo.prototype.setCreatetimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint64 closeTimestamp = 8;
 * @return {number}
 */
proto.proto.Entity.ChannelInfo.prototype.getClosetimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelInfo} returns this
 */
proto.proto.Entity.ChannelInfo.prototype.setClosetimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool isAlive = 9;
 * @return {boolean}
 */
proto.proto.Entity.ChannelInfo.prototype.getIsalive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ChannelInfo} returns this
 */
proto.proto.Entity.ChannelInfo.prototype.setIsalive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional uint32 sessionSource = 10;
 * @return {number}
 */
proto.proto.Entity.ChannelInfo.prototype.getSessionsource = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ChannelInfo} returns this
 */
proto.proto.Entity.ChannelInfo.prototype.setSessionsource = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ChannelList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ChannelList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ChannelList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ChannelList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelList.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.proto.Entity.ChannelInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ChannelList}
 */
proto.proto.Entity.ChannelList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ChannelList;
  return proto.proto.Entity.ChannelList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ChannelList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ChannelList}
 */
proto.proto.Entity.ChannelList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.ChannelInfo;
      reader.readMessage(value,proto.proto.Entity.ChannelInfo.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ChannelList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ChannelList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ChannelList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ChannelList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.ChannelInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ChannelInfo list = 1;
 * @return {!Array<!proto.proto.Entity.ChannelInfo>}
 */
proto.proto.Entity.ChannelList.prototype.getListList = function() {
  return /** @type{!Array<!proto.proto.Entity.ChannelInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.ChannelInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.ChannelInfo>} value
 * @return {!proto.proto.Entity.ChannelList} returns this
*/
proto.proto.Entity.ChannelList.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.ChannelInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ChannelInfo}
 */
proto.proto.Entity.ChannelList.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.ChannelInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ChannelList} returns this
 */
proto.proto.Entity.ChannelList.prototype.clearListList = function() {
  return this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ContactBaseData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ContactBaseData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ContactBaseData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ContactBaseData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ContactBaseData.toObject = function(includeInstance, msg) {
  var f, obj = {
    contactarrayList: jspb.Message.toObjectList(msg.getContactarrayList(),
    proto.proto.Entity.ContactBaseInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ContactBaseData}
 */
proto.proto.Entity.ContactBaseData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ContactBaseData;
  return proto.proto.Entity.ContactBaseData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ContactBaseData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ContactBaseData}
 */
proto.proto.Entity.ContactBaseData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.ContactBaseInfo;
      reader.readMessage(value,proto.proto.Entity.ContactBaseInfo.deserializeBinaryFromReader);
      msg.addContactarray(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ContactBaseData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ContactBaseData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ContactBaseData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ContactBaseData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContactarrayList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.ContactBaseInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ContactBaseInfo contactArray = 1;
 * @return {!Array<!proto.proto.Entity.ContactBaseInfo>}
 */
proto.proto.Entity.ContactBaseData.prototype.getContactarrayList = function() {
  return /** @type{!Array<!proto.proto.Entity.ContactBaseInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.ContactBaseInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.ContactBaseInfo>} value
 * @return {!proto.proto.Entity.ContactBaseData} returns this
*/
proto.proto.Entity.ContactBaseData.prototype.setContactarrayList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.ContactBaseInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ContactBaseInfo}
 */
proto.proto.Entity.ContactBaseData.prototype.addContactarray = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.ContactBaseInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ContactBaseData} returns this
 */
proto.proto.Entity.ContactBaseData.prototype.clearContactarrayList = function() {
  return this.setContactarrayList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ContactBaseInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ContactBaseInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ContactBaseInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ContactBaseInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    corpid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    avatarurl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    corpname: jspb.Message.getFieldWithDefault(msg, 5, ""),
    namespell: jspb.Message.getFieldWithDefault(msg, 6, ""),
    onlinestatus: jspb.Message.getFieldWithDefault(msg, 8, 0),
    devicetype: jspb.Message.getFieldWithDefault(msg, 9, 0),
    offlinereason: jspb.Message.getFieldWithDefault(msg, 10, 0),
    mobile: jspb.Message.getFieldWithDefault(msg, 11, ""),
    email: jspb.Message.getFieldWithDefault(msg, 12, ""),
    status: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ContactBaseInfo}
 */
proto.proto.Entity.ContactBaseInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ContactBaseInfo;
  return proto.proto.Entity.ContactBaseInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ContactBaseInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ContactBaseInfo}
 */
proto.proto.Entity.ContactBaseInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarurl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespell(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOnlinestatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDevicetype(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOfflinereason(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ContactBaseInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ContactBaseInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ContactBaseInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ContactBaseInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAvatarurl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCorpname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNamespell();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOnlinestatus();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getDevicetype();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getOfflinereason();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
};


/**
 * optional string corpId = 1;
 * @return {string}
 */
proto.proto.Entity.ContactBaseInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactBaseInfo} returns this
 */
proto.proto.Entity.ContactBaseInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string userId = 2;
 * @return {string}
 */
proto.proto.Entity.ContactBaseInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactBaseInfo} returns this
 */
proto.proto.Entity.ContactBaseInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.proto.Entity.ContactBaseInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactBaseInfo} returns this
 */
proto.proto.Entity.ContactBaseInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string avatarUrl = 4;
 * @return {string}
 */
proto.proto.Entity.ContactBaseInfo.prototype.getAvatarurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactBaseInfo} returns this
 */
proto.proto.Entity.ContactBaseInfo.prototype.setAvatarurl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string corpName = 5;
 * @return {string}
 */
proto.proto.Entity.ContactBaseInfo.prototype.getCorpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactBaseInfo} returns this
 */
proto.proto.Entity.ContactBaseInfo.prototype.setCorpname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string nameSpell = 6;
 * @return {string}
 */
proto.proto.Entity.ContactBaseInfo.prototype.getNamespell = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactBaseInfo} returns this
 */
proto.proto.Entity.ContactBaseInfo.prototype.setNamespell = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint32 onlineStatus = 8;
 * @return {number}
 */
proto.proto.Entity.ContactBaseInfo.prototype.getOnlinestatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ContactBaseInfo} returns this
 */
proto.proto.Entity.ContactBaseInfo.prototype.setOnlinestatus = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 deviceType = 9;
 * @return {number}
 */
proto.proto.Entity.ContactBaseInfo.prototype.getDevicetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ContactBaseInfo} returns this
 */
proto.proto.Entity.ContactBaseInfo.prototype.setDevicetype = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional uint32 offlineReason = 10;
 * @return {number}
 */
proto.proto.Entity.ContactBaseInfo.prototype.getOfflinereason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ContactBaseInfo} returns this
 */
proto.proto.Entity.ContactBaseInfo.prototype.setOfflinereason = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string mobile = 11;
 * @return {string}
 */
proto.proto.Entity.ContactBaseInfo.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactBaseInfo} returns this
 */
proto.proto.Entity.ContactBaseInfo.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string email = 12;
 * @return {string}
 */
proto.proto.Entity.ContactBaseInfo.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactBaseInfo} returns this
 */
proto.proto.Entity.ContactBaseInfo.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional uint32 status = 13;
 * @return {number}
 */
proto.proto.Entity.ContactBaseInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ContactBaseInfo} returns this
 */
proto.proto.Entity.ContactBaseInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.SubOrganizationInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.SubOrganizationInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.SubOrganizationInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.SubOrganizationInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    parentid: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.SubOrganizationInfo}
 */
proto.proto.Entity.SubOrganizationInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.SubOrganizationInfo;
  return proto.proto.Entity.SubOrganizationInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.SubOrganizationInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.SubOrganizationInfo}
 */
proto.proto.Entity.SubOrganizationInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setParentid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.SubOrganizationInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.SubOrganizationInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.SubOrganizationInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.SubOrganizationInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParentid();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional uint32 orgId = 1;
 * @return {number}
 */
proto.proto.Entity.SubOrganizationInfo.prototype.getOrgid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.SubOrganizationInfo} returns this
 */
proto.proto.Entity.SubOrganizationInfo.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.proto.Entity.SubOrganizationInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.SubOrganizationInfo} returns this
 */
proto.proto.Entity.SubOrganizationInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 parentId = 3;
 * @return {number}
 */
proto.proto.Entity.SubOrganizationInfo.prototype.getParentid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.SubOrganizationInfo} returns this
 */
proto.proto.Entity.SubOrganizationInfo.prototype.setParentid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.SubOrganizationNode.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.SubOrganizationNode.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.SubOrganizationNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.SubOrganizationNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.SubOrganizationNode.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    childsList: jspb.Message.toObjectList(msg.getChildsList(),
    proto.proto.Entity.SubOrganizationInfo.toObject, includeInstance),
    useridlistList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.SubOrganizationNode}
 */
proto.proto.Entity.SubOrganizationNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.SubOrganizationNode;
  return proto.proto.Entity.SubOrganizationNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.SubOrganizationNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.SubOrganizationNode}
 */
proto.proto.Entity.SubOrganizationNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOrgid(value);
      break;
    case 2:
      var value = new proto.proto.Entity.SubOrganizationInfo;
      reader.readMessage(value,proto.proto.Entity.SubOrganizationInfo.deserializeBinaryFromReader);
      msg.addChilds(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addUseridlist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.SubOrganizationNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.SubOrganizationNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.SubOrganizationNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.SubOrganizationNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getChildsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.proto.Entity.SubOrganizationInfo.serializeBinaryToWriter
    );
  }
  f = message.getUseridlistList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional uint32 orgId = 1;
 * @return {number}
 */
proto.proto.Entity.SubOrganizationNode.prototype.getOrgid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.SubOrganizationNode} returns this
 */
proto.proto.Entity.SubOrganizationNode.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated SubOrganizationInfo childs = 2;
 * @return {!Array<!proto.proto.Entity.SubOrganizationInfo>}
 */
proto.proto.Entity.SubOrganizationNode.prototype.getChildsList = function() {
  return /** @type{!Array<!proto.proto.Entity.SubOrganizationInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.SubOrganizationInfo, 2));
};


/**
 * @param {!Array<!proto.proto.Entity.SubOrganizationInfo>} value
 * @return {!proto.proto.Entity.SubOrganizationNode} returns this
*/
proto.proto.Entity.SubOrganizationNode.prototype.setChildsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.proto.Entity.SubOrganizationInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.SubOrganizationInfo}
 */
proto.proto.Entity.SubOrganizationNode.prototype.addChilds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.proto.Entity.SubOrganizationInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.SubOrganizationNode} returns this
 */
proto.proto.Entity.SubOrganizationNode.prototype.clearChildsList = function() {
  return this.setChildsList([]);
};


/**
 * repeated string userIdList = 3;
 * @return {!Array<string>}
 */
proto.proto.Entity.SubOrganizationNode.prototype.getUseridlistList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.SubOrganizationNode} returns this
 */
proto.proto.Entity.SubOrganizationNode.prototype.setUseridlistList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.SubOrganizationNode} returns this
 */
proto.proto.Entity.SubOrganizationNode.prototype.addUseridlist = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.SubOrganizationNode} returns this
 */
proto.proto.Entity.SubOrganizationNode.prototype.clearUseridlistList = function() {
  return this.setUseridlistList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.CorpOrganizationNode.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.CorpOrganizationNode.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.CorpOrganizationNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.CorpOrganizationNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.CorpOrganizationNode.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    parentid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    count: jspb.Message.getFieldWithDefault(msg, 4, 0),
    childsList: jspb.Message.toObjectList(msg.getChildsList(),
    proto.proto.Entity.CorpOrganizationNode.toObject, includeInstance),
    usersList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.CorpOrganizationNode}
 */
proto.proto.Entity.CorpOrganizationNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.CorpOrganizationNode;
  return proto.proto.Entity.CorpOrganizationNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.CorpOrganizationNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.CorpOrganizationNode}
 */
proto.proto.Entity.CorpOrganizationNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setParentid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCount(value);
      break;
    case 5:
      var value = new proto.proto.Entity.CorpOrganizationNode;
      reader.readMessage(value,proto.proto.Entity.CorpOrganizationNode.deserializeBinaryFromReader);
      msg.addChilds(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.CorpOrganizationNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.CorpOrganizationNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.CorpOrganizationNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.CorpOrganizationNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParentid();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getChildsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.proto.Entity.CorpOrganizationNode.serializeBinaryToWriter
    );
  }
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
};


/**
 * optional uint32 orgId = 1;
 * @return {number}
 */
proto.proto.Entity.CorpOrganizationNode.prototype.getOrgid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.CorpOrganizationNode} returns this
 */
proto.proto.Entity.CorpOrganizationNode.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.proto.Entity.CorpOrganizationNode.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpOrganizationNode} returns this
 */
proto.proto.Entity.CorpOrganizationNode.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 parentId = 3;
 * @return {number}
 */
proto.proto.Entity.CorpOrganizationNode.prototype.getParentid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.CorpOrganizationNode} returns this
 */
proto.proto.Entity.CorpOrganizationNode.prototype.setParentid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 count = 4;
 * @return {number}
 */
proto.proto.Entity.CorpOrganizationNode.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.CorpOrganizationNode} returns this
 */
proto.proto.Entity.CorpOrganizationNode.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated CorpOrganizationNode childs = 5;
 * @return {!Array<!proto.proto.Entity.CorpOrganizationNode>}
 */
proto.proto.Entity.CorpOrganizationNode.prototype.getChildsList = function() {
  return /** @type{!Array<!proto.proto.Entity.CorpOrganizationNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.CorpOrganizationNode, 5));
};


/**
 * @param {!Array<!proto.proto.Entity.CorpOrganizationNode>} value
 * @return {!proto.proto.Entity.CorpOrganizationNode} returns this
*/
proto.proto.Entity.CorpOrganizationNode.prototype.setChildsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.proto.Entity.CorpOrganizationNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.CorpOrganizationNode}
 */
proto.proto.Entity.CorpOrganizationNode.prototype.addChilds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.proto.Entity.CorpOrganizationNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.CorpOrganizationNode} returns this
 */
proto.proto.Entity.CorpOrganizationNode.prototype.clearChildsList = function() {
  return this.setChildsList([]);
};


/**
 * repeated string users = 6;
 * @return {!Array<string>}
 */
proto.proto.Entity.CorpOrganizationNode.prototype.getUsersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.CorpOrganizationNode} returns this
 */
proto.proto.Entity.CorpOrganizationNode.prototype.setUsersList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.CorpOrganizationNode} returns this
 */
proto.proto.Entity.CorpOrganizationNode.prototype.addUsers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.CorpOrganizationNode} returns this
 */
proto.proto.Entity.CorpOrganizationNode.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.CorpOrganizationInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.CorpOrganizationInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.CorpOrganizationInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.CorpOrganizationInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    corpid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    node: (f = msg.getNode()) && proto.proto.Entity.CorpOrganizationNode.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.CorpOrganizationInfo}
 */
proto.proto.Entity.CorpOrganizationInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.CorpOrganizationInfo;
  return proto.proto.Entity.CorpOrganizationInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.CorpOrganizationInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.CorpOrganizationInfo}
 */
proto.proto.Entity.CorpOrganizationInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 2:
      var value = new proto.proto.Entity.CorpOrganizationNode;
      reader.readMessage(value,proto.proto.Entity.CorpOrganizationNode.deserializeBinaryFromReader);
      msg.setNode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.CorpOrganizationInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.CorpOrganizationInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.CorpOrganizationInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.CorpOrganizationInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNode();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.Entity.CorpOrganizationNode.serializeBinaryToWriter
    );
  }
};


/**
 * optional string corpId = 1;
 * @return {string}
 */
proto.proto.Entity.CorpOrganizationInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpOrganizationInfo} returns this
 */
proto.proto.Entity.CorpOrganizationInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CorpOrganizationNode node = 2;
 * @return {?proto.proto.Entity.CorpOrganizationNode}
 */
proto.proto.Entity.CorpOrganizationInfo.prototype.getNode = function() {
  return /** @type{?proto.proto.Entity.CorpOrganizationNode} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.CorpOrganizationNode, 2));
};


/**
 * @param {?proto.proto.Entity.CorpOrganizationNode|undefined} value
 * @return {!proto.proto.Entity.CorpOrganizationInfo} returns this
*/
proto.proto.Entity.CorpOrganizationInfo.prototype.setNode = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.CorpOrganizationInfo} returns this
 */
proto.proto.Entity.CorpOrganizationInfo.prototype.clearNode = function() {
  return this.setNode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.CorpOrganizationInfo.prototype.hasNode = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.InviteDynamicData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.InviteDynamicData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.InviteDynamicData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.InviteDynamicData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.InviteDynamicData.toObject = function(includeInstance, msg) {
  var f, obj = {
    invitearrayList: jspb.Message.toObjectList(msg.getInvitearrayList(),
    proto.proto.Entity.InviteDynamicDetailInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.InviteDynamicData}
 */
proto.proto.Entity.InviteDynamicData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.InviteDynamicData;
  return proto.proto.Entity.InviteDynamicData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.InviteDynamicData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.InviteDynamicData}
 */
proto.proto.Entity.InviteDynamicData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.InviteDynamicDetailInfo;
      reader.readMessage(value,proto.proto.Entity.InviteDynamicDetailInfo.deserializeBinaryFromReader);
      msg.addInvitearray(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.InviteDynamicData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.InviteDynamicData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.InviteDynamicData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.InviteDynamicData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvitearrayList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.InviteDynamicDetailInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated InviteDynamicDetailInfo inviteArray = 1;
 * @return {!Array<!proto.proto.Entity.InviteDynamicDetailInfo>}
 */
proto.proto.Entity.InviteDynamicData.prototype.getInvitearrayList = function() {
  return /** @type{!Array<!proto.proto.Entity.InviteDynamicDetailInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.InviteDynamicDetailInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.InviteDynamicDetailInfo>} value
 * @return {!proto.proto.Entity.InviteDynamicData} returns this
*/
proto.proto.Entity.InviteDynamicData.prototype.setInvitearrayList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.InviteDynamicDetailInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.InviteDynamicDetailInfo}
 */
proto.proto.Entity.InviteDynamicData.prototype.addInvitearray = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.InviteDynamicDetailInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.InviteDynamicData} returns this
 */
proto.proto.Entity.InviteDynamicData.prototype.clearInvitearrayList = function() {
  return this.setInvitearrayList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.InviteInfo.repeatedFields_ = [13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.InviteInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.InviteInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.InviteInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.InviteInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    inviteid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    source: jspb.Message.getFieldWithDefault(msg, 3, 0),
    userid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    email: jspb.Message.getFieldWithDefault(msg, 6, ""),
    position: jspb.Message.getFieldWithDefault(msg, 7, ""),
    avatarurl: jspb.Message.getFieldWithDefault(msg, 8, ""),
    sensitivemobile: jspb.Message.getFieldWithDefault(msg, 9, ""),
    corpid: jspb.Message.getFieldWithDefault(msg, 10, ""),
    sensitivecorpname: jspb.Message.getFieldWithDefault(msg, 11, ""),
    lastmodifytime: jspb.Message.getFieldWithDefault(msg, 12, ""),
    ownerorglistList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.InviteInfo}
 */
proto.proto.Entity.InviteInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.InviteInfo;
  return proto.proto.Entity.InviteInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.InviteInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.InviteInfo}
 */
proto.proto.Entity.InviteInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInviteid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSource(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPosition(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarurl(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSensitivemobile(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSensitivecorpname(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastmodifytime(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addOwnerorglist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.InviteInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.InviteInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.InviteInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.InviteInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInviteid();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getSource();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPosition();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAvatarurl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSensitivemobile();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSensitivecorpname();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLastmodifytime();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getOwnerorglistList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
};


/**
 * optional uint32 inviteId = 1;
 * @return {number}
 */
proto.proto.Entity.InviteInfo.prototype.getInviteid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setInviteid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 status = 2;
 * @return {number}
 */
proto.proto.Entity.InviteInfo.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 source = 3;
 * @return {number}
 */
proto.proto.Entity.InviteInfo.prototype.getSource = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setSource = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string userId = 4;
 * @return {string}
 */
proto.proto.Entity.InviteInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string name = 5;
 * @return {string}
 */
proto.proto.Entity.InviteInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string email = 6;
 * @return {string}
 */
proto.proto.Entity.InviteInfo.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string position = 7;
 * @return {string}
 */
proto.proto.Entity.InviteInfo.prototype.getPosition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setPosition = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string avatarUrl = 8;
 * @return {string}
 */
proto.proto.Entity.InviteInfo.prototype.getAvatarurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setAvatarurl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string sensitiveMobile = 9;
 * @return {string}
 */
proto.proto.Entity.InviteInfo.prototype.getSensitivemobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setSensitivemobile = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string corpId = 10;
 * @return {string}
 */
proto.proto.Entity.InviteInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string sensitiveCorpName = 11;
 * @return {string}
 */
proto.proto.Entity.InviteInfo.prototype.getSensitivecorpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setSensitivecorpname = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string lastModifyTime = 12;
 * @return {string}
 */
proto.proto.Entity.InviteInfo.prototype.getLastmodifytime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setLastmodifytime = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * repeated string ownerOrgList = 13;
 * @return {!Array<string>}
 */
proto.proto.Entity.InviteInfo.prototype.getOwnerorglistList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.setOwnerorglistList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.addOwnerorglist = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.InviteInfo} returns this
 */
proto.proto.Entity.InviteInfo.prototype.clearOwnerorglistList = function() {
  return this.setOwnerorglistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ShareInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ShareInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ShareInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ShareInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    shareid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    shareuserid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    avatar: jspb.Message.getFieldWithDefault(msg, 5, ""),
    corpname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    createtime: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ShareInfo}
 */
proto.proto.Entity.ShareInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ShareInfo;
  return proto.proto.Entity.ShareInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ShareInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ShareInfo}
 */
proto.proto.Entity.ShareInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setShareid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShareuserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatar(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpname(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatetime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ShareInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ShareInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ShareInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ShareInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShareid();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getShareuserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAvatar();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCorpname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatetime();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional uint32 shareId = 1;
 * @return {number}
 */
proto.proto.Entity.ShareInfo.prototype.getShareid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ShareInfo} returns this
 */
proto.proto.Entity.ShareInfo.prototype.setShareid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string shareUserId = 2;
 * @return {string}
 */
proto.proto.Entity.ShareInfo.prototype.getShareuserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ShareInfo} returns this
 */
proto.proto.Entity.ShareInfo.prototype.setShareuserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string userId = 3;
 * @return {string}
 */
proto.proto.Entity.ShareInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ShareInfo} returns this
 */
proto.proto.Entity.ShareInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.proto.Entity.ShareInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ShareInfo} returns this
 */
proto.proto.Entity.ShareInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string avatar = 5;
 * @return {string}
 */
proto.proto.Entity.ShareInfo.prototype.getAvatar = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ShareInfo} returns this
 */
proto.proto.Entity.ShareInfo.prototype.setAvatar = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string corpName = 6;
 * @return {string}
 */
proto.proto.Entity.ShareInfo.prototype.getCorpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ShareInfo} returns this
 */
proto.proto.Entity.ShareInfo.prototype.setCorpname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string createTime = 7;
 * @return {string}
 */
proto.proto.Entity.ShareInfo.prototype.getCreatetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ShareInfo} returns this
 */
proto.proto.Entity.ShareInfo.prototype.setCreatetime = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.InviteDynamicDetailInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.InviteDynamicDetailInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.InviteDynamicDetailInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.InviteDynamicDetailInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    inviteinfo: (f = msg.getInviteinfo()) && proto.proto.Entity.InviteInfo.toObject(includeInstance, f),
    shareinfo: (f = msg.getShareinfo()) && proto.proto.Entity.ShareInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.InviteDynamicDetailInfo}
 */
proto.proto.Entity.InviteDynamicDetailInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.InviteDynamicDetailInfo;
  return proto.proto.Entity.InviteDynamicDetailInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.InviteDynamicDetailInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.InviteDynamicDetailInfo}
 */
proto.proto.Entity.InviteDynamicDetailInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.proto.Entity.InviteInfo;
      reader.readMessage(value,proto.proto.Entity.InviteInfo.deserializeBinaryFromReader);
      msg.setInviteinfo(value);
      break;
    case 3:
      var value = new proto.proto.Entity.ShareInfo;
      reader.readMessage(value,proto.proto.Entity.ShareInfo.deserializeBinaryFromReader);
      msg.setShareinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.InviteDynamicDetailInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.InviteDynamicDetailInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.InviteDynamicDetailInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.InviteDynamicDetailInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getInviteinfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.Entity.InviteInfo.serializeBinaryToWriter
    );
  }
  f = message.getShareinfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.Entity.ShareInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 type = 1;
 * @return {number}
 */
proto.proto.Entity.InviteDynamicDetailInfo.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.InviteDynamicDetailInfo} returns this
 */
proto.proto.Entity.InviteDynamicDetailInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional InviteInfo inviteInfo = 2;
 * @return {?proto.proto.Entity.InviteInfo}
 */
proto.proto.Entity.InviteDynamicDetailInfo.prototype.getInviteinfo = function() {
  return /** @type{?proto.proto.Entity.InviteInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.InviteInfo, 2));
};


/**
 * @param {?proto.proto.Entity.InviteInfo|undefined} value
 * @return {!proto.proto.Entity.InviteDynamicDetailInfo} returns this
*/
proto.proto.Entity.InviteDynamicDetailInfo.prototype.setInviteinfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.InviteDynamicDetailInfo} returns this
 */
proto.proto.Entity.InviteDynamicDetailInfo.prototype.clearInviteinfo = function() {
  return this.setInviteinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.InviteDynamicDetailInfo.prototype.hasInviteinfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ShareInfo shareInfo = 3;
 * @return {?proto.proto.Entity.ShareInfo}
 */
proto.proto.Entity.InviteDynamicDetailInfo.prototype.getShareinfo = function() {
  return /** @type{?proto.proto.Entity.ShareInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.ShareInfo, 3));
};


/**
 * @param {?proto.proto.Entity.ShareInfo|undefined} value
 * @return {!proto.proto.Entity.InviteDynamicDetailInfo} returns this
*/
proto.proto.Entity.InviteDynamicDetailInfo.prototype.setShareinfo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.InviteDynamicDetailInfo} returns this
 */
proto.proto.Entity.InviteDynamicDetailInfo.prototype.clearShareinfo = function() {
  return this.setShareinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.InviteDynamicDetailInfo.prototype.hasShareinfo = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ExternalContactInfo.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ExternalContactInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ExternalContactInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ExternalContactInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ExternalContactInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    isadded: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    ishileiagranted: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    cockey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    mobile: jspb.Message.getFieldWithDefault(msg, 5, ""),
    email: jspb.Message.getFieldWithDefault(msg, 6, ""),
    loginname: jspb.Message.getFieldWithDefault(msg, 7, ""),
    corpname: jspb.Message.getFieldWithDefault(msg, 8, ""),
    position: jspb.Message.getFieldWithDefault(msg, 9, ""),
    avatarurl: jspb.Message.getFieldWithDefault(msg, 10, ""),
    orgnamesList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ExternalContactInfo}
 */
proto.proto.Entity.ExternalContactInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ExternalContactInfo;
  return proto.proto.Entity.ExternalContactInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ExternalContactInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ExternalContactInfo}
 */
proto.proto.Entity.ExternalContactInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsadded(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIshileiagranted(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCockey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobile(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoginname(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpname(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPosition(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarurl(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addOrgnames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ExternalContactInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ExternalContactInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ExternalContactInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ExternalContactInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsadded();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getIshileiagranted();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getCockey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMobile();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLoginname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCorpname();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPosition();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAvatarurl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getOrgnamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
};


/**
 * optional bool isAdded = 1;
 * @return {boolean}
 */
proto.proto.Entity.ExternalContactInfo.prototype.getIsadded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.setIsadded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool isHiLeiaGranted = 2;
 * @return {boolean}
 */
proto.proto.Entity.ExternalContactInfo.prototype.getIshileiagranted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.setIshileiagranted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string cocKey = 3;
 * @return {string}
 */
proto.proto.Entity.ExternalContactInfo.prototype.getCockey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.setCockey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.proto.Entity.ExternalContactInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string mobile = 5;
 * @return {string}
 */
proto.proto.Entity.ExternalContactInfo.prototype.getMobile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.setMobile = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string email = 6;
 * @return {string}
 */
proto.proto.Entity.ExternalContactInfo.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string loginName = 7;
 * @return {string}
 */
proto.proto.Entity.ExternalContactInfo.prototype.getLoginname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.setLoginname = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string corpName = 8;
 * @return {string}
 */
proto.proto.Entity.ExternalContactInfo.prototype.getCorpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.setCorpname = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string position = 9;
 * @return {string}
 */
proto.proto.Entity.ExternalContactInfo.prototype.getPosition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.setPosition = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string avatarUrl = 10;
 * @return {string}
 */
proto.proto.Entity.ExternalContactInfo.prototype.getAvatarurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.setAvatarurl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated string orgNames = 11;
 * @return {!Array<string>}
 */
proto.proto.Entity.ExternalContactInfo.prototype.getOrgnamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.setOrgnamesList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.addOrgnames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ExternalContactInfo} returns this
 */
proto.proto.Entity.ExternalContactInfo.prototype.clearOrgnamesList = function() {
  return this.setOrgnamesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.CorpData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.CorpData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.CorpData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.CorpData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.CorpData.toObject = function(includeInstance, msg) {
  var f, obj = {
    corparrayList: jspb.Message.toObjectList(msg.getCorparrayList(),
    proto.proto.Entity.CorpInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.CorpData}
 */
proto.proto.Entity.CorpData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.CorpData;
  return proto.proto.Entity.CorpData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.CorpData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.CorpData}
 */
proto.proto.Entity.CorpData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.CorpInfo;
      reader.readMessage(value,proto.proto.Entity.CorpInfo.deserializeBinaryFromReader);
      msg.addCorparray(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.CorpData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.CorpData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.CorpData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.CorpData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorparrayList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.CorpInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CorpInfo CorpArray = 1;
 * @return {!Array<!proto.proto.Entity.CorpInfo>}
 */
proto.proto.Entity.CorpData.prototype.getCorparrayList = function() {
  return /** @type{!Array<!proto.proto.Entity.CorpInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.CorpInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.CorpInfo>} value
 * @return {!proto.proto.Entity.CorpData} returns this
*/
proto.proto.Entity.CorpData.prototype.setCorparrayList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.CorpInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.CorpInfo}
 */
proto.proto.Entity.CorpData.prototype.addCorparray = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.CorpInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.CorpData} returns this
 */
proto.proto.Entity.CorpData.prototype.clearCorparrayList = function() {
  return this.setCorparrayList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.CorpInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.CorpInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.CorpInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.CorpInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    corpid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    namespell: jspb.Message.getFieldWithDefault(msg, 3, ""),
    searchstring: jspb.Message.getFieldWithDefault(msg, 4, ""),
    logo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    province: jspb.Message.getFieldWithDefault(msg, 6, ""),
    city: jspb.Message.getFieldWithDefault(msg, 7, ""),
    district: jspb.Message.getFieldWithDefault(msg, 8, ""),
    address: jspb.Message.getFieldWithDefault(msg, 9, ""),
    describe: jspb.Message.getFieldWithDefault(msg, 10, ""),
    longitude: jspb.Message.getFieldWithDefault(msg, 11, ""),
    latitude: jspb.Message.getFieldWithDefault(msg, 12, ""),
    createtime: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.CorpInfo}
 */
proto.proto.Entity.CorpInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.CorpInfo;
  return proto.proto.Entity.CorpInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.CorpInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.CorpInfo}
 */
proto.proto.Entity.CorpInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setNamespell(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchstring(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvince(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDistrict(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescribe(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongitude(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLatitude(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatetime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.CorpInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.CorpInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.CorpInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.CorpInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNamespell();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSearchstring();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLogo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProvince();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDistrict();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDescribe();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLongitude();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLatitude();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCreatetime();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string corpId = 1;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string nameSpell = 3;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getNamespell = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setNamespell = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string searchString = 4;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getSearchstring = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setSearchstring = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string logo = 5;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getLogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setLogo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string province = 6;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getProvince = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setProvince = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string city = 7;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string district = 8;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getDistrict = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setDistrict = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string address = 9;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string describe = 10;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getDescribe = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setDescribe = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string longitude = 11;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getLongitude = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string latitude = 12;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getLatitude = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string createTime = 13;
 * @return {string}
 */
proto.proto.Entity.CorpInfo.prototype.getCreatetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.CorpInfo} returns this
 */
proto.proto.Entity.CorpInfo.prototype.setCreatetime = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.RecentCorpList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.RecentCorpList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.RecentCorpList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.RecentCorpList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.RecentCorpList.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: jspb.Message.toObjectList(msg.getListList(),
    proto.proto.Entity.CorpInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.RecentCorpList}
 */
proto.proto.Entity.RecentCorpList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.RecentCorpList;
  return proto.proto.Entity.RecentCorpList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.RecentCorpList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.RecentCorpList}
 */
proto.proto.Entity.RecentCorpList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.CorpInfo;
      reader.readMessage(value,proto.proto.Entity.CorpInfo.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.RecentCorpList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.RecentCorpList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.RecentCorpList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.RecentCorpList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.CorpInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CorpInfo list = 1;
 * @return {!Array<!proto.proto.Entity.CorpInfo>}
 */
proto.proto.Entity.RecentCorpList.prototype.getListList = function() {
  return /** @type{!Array<!proto.proto.Entity.CorpInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.CorpInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.CorpInfo>} value
 * @return {!proto.proto.Entity.RecentCorpList} returns this
*/
proto.proto.Entity.RecentCorpList.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.CorpInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.CorpInfo}
 */
proto.proto.Entity.RecentCorpList.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.CorpInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.RecentCorpList} returns this
 */
proto.proto.Entity.RecentCorpList.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.InviteNotifyInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.InviteNotifyInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.InviteNotifyInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.InviteNotifyInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    inviteid: jspb.Message.getFieldWithDefault(msg, 2, 0),
    corpid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.InviteNotifyInfo}
 */
proto.proto.Entity.InviteNotifyInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.InviteNotifyInfo;
  return proto.proto.Entity.InviteNotifyInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.InviteNotifyInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.InviteNotifyInfo}
 */
proto.proto.Entity.InviteNotifyInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInviteid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.InviteNotifyInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.InviteNotifyInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.InviteNotifyInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.InviteNotifyInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getInviteid();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint32 type = 1;
 * @return {number}
 */
proto.proto.Entity.InviteNotifyInfo.prototype.getType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.InviteNotifyInfo} returns this
 */
proto.proto.Entity.InviteNotifyInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 inviteId = 2;
 * @return {number}
 */
proto.proto.Entity.InviteNotifyInfo.prototype.getInviteid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.InviteNotifyInfo} returns this
 */
proto.proto.Entity.InviteNotifyInfo.prototype.setInviteid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string corpId = 3;
 * @return {string}
 */
proto.proto.Entity.InviteNotifyInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.InviteNotifyInfo} returns this
 */
proto.proto.Entity.InviteNotifyInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string userId = 4;
 * @return {string}
 */
proto.proto.Entity.InviteNotifyInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.InviteNotifyInfo} returns this
 */
proto.proto.Entity.InviteNotifyInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.TagList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.TagList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.TagList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.TagList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.TagList.toObject = function(includeInstance, msg) {
  var f, obj = {
    taginfolistList: jspb.Message.toObjectList(msg.getTaginfolistList(),
    proto.proto.Entity.TagInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.TagList}
 */
proto.proto.Entity.TagList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.TagList;
  return proto.proto.Entity.TagList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.TagList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.TagList}
 */
proto.proto.Entity.TagList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.TagInfo;
      reader.readMessage(value,proto.proto.Entity.TagInfo.deserializeBinaryFromReader);
      msg.addTaginfolist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.TagList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.TagList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.TagList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.TagList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaginfolistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.TagInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TagInfo tagInfoList = 1;
 * @return {!Array<!proto.proto.Entity.TagInfo>}
 */
proto.proto.Entity.TagList.prototype.getTaginfolistList = function() {
  return /** @type{!Array<!proto.proto.Entity.TagInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.TagInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.TagInfo>} value
 * @return {!proto.proto.Entity.TagList} returns this
*/
proto.proto.Entity.TagList.prototype.setTaginfolistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.TagInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.TagInfo}
 */
proto.proto.Entity.TagList.prototype.addTaginfolist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.TagInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.TagList} returns this
 */
proto.proto.Entity.TagList.prototype.clearTaginfolistList = function() {
  return this.setTaginfolistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.TagInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.TagInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.TagInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.TagInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.TagInfo}
 */
proto.proto.Entity.TagInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.TagInfo;
  return proto.proto.Entity.TagInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.TagInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.TagInfo}
 */
proto.proto.Entity.TagInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.TagInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.TagInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.TagInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.TagInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.proto.Entity.TagInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.TagInfo} returns this
 */
proto.proto.Entity.TagInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.proto.Entity.TagInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.TagInfo} returns this
 */
proto.proto.Entity.TagInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.AttachmentList.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.AttachmentList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.AttachmentList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.AttachmentList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AttachmentList.toObject = function(includeInstance, msg) {
  var f, obj = {
    uniquekey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    attachmentinfolistList: jspb.Message.toObjectList(msg.getAttachmentinfolistList(),
    proto.proto.Entity.AttachmentInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.AttachmentList}
 */
proto.proto.Entity.AttachmentList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.AttachmentList;
  return proto.proto.Entity.AttachmentList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.AttachmentList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.AttachmentList}
 */
proto.proto.Entity.AttachmentList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUniquekey(value);
      break;
    case 2:
      var value = new proto.proto.Entity.AttachmentInfo;
      reader.readMessage(value,proto.proto.Entity.AttachmentInfo.deserializeBinaryFromReader);
      msg.addAttachmentinfolist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.AttachmentList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.AttachmentList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.AttachmentList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AttachmentList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUniquekey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAttachmentinfolistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.proto.Entity.AttachmentInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uniqueKey = 1;
 * @return {string}
 */
proto.proto.Entity.AttachmentList.prototype.getUniquekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AttachmentList} returns this
 */
proto.proto.Entity.AttachmentList.prototype.setUniquekey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated AttachmentInfo attachmentInfoList = 2;
 * @return {!Array<!proto.proto.Entity.AttachmentInfo>}
 */
proto.proto.Entity.AttachmentList.prototype.getAttachmentinfolistList = function() {
  return /** @type{!Array<!proto.proto.Entity.AttachmentInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.AttachmentInfo, 2));
};


/**
 * @param {!Array<!proto.proto.Entity.AttachmentInfo>} value
 * @return {!proto.proto.Entity.AttachmentList} returns this
*/
proto.proto.Entity.AttachmentList.prototype.setAttachmentinfolistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.proto.Entity.AttachmentInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.AttachmentInfo}
 */
proto.proto.Entity.AttachmentList.prototype.addAttachmentinfolist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.proto.Entity.AttachmentInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.AttachmentList} returns this
 */
proto.proto.Entity.AttachmentList.prototype.clearAttachmentinfolistList = function() {
  return this.setAttachmentinfolistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.AttachmentInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.AttachmentInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.AttachmentInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AttachmentInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    fid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    url: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    addtime: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.AttachmentInfo}
 */
proto.proto.Entity.AttachmentInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.AttachmentInfo;
  return proto.proto.Entity.AttachmentInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.AttachmentInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.AttachmentInfo}
 */
proto.proto.Entity.AttachmentInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.AttachmentInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.AttachmentInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.AttachmentInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AttachmentInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAddtime();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string fid = 1;
 * @return {string}
 */
proto.proto.Entity.AttachmentInfo.prototype.getFid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AttachmentInfo} returns this
 */
proto.proto.Entity.AttachmentInfo.prototype.setFid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.proto.Entity.AttachmentInfo.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AttachmentInfo} returns this
 */
proto.proto.Entity.AttachmentInfo.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.proto.Entity.AttachmentInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AttachmentInfo} returns this
 */
proto.proto.Entity.AttachmentInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string userId = 4;
 * @return {string}
 */
proto.proto.Entity.AttachmentInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AttachmentInfo} returns this
 */
proto.proto.Entity.AttachmentInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string addTime = 5;
 * @return {string}
 */
proto.proto.Entity.AttachmentInfo.prototype.getAddtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AttachmentInfo} returns this
 */
proto.proto.Entity.AttachmentInfo.prototype.setAddtime = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ConferenceMemberInfo.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConferenceMemberInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConferenceMemberInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceMemberInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    corpid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    corpname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    nickname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    corpnamespell: jspb.Message.getFieldWithDefault(msg, 5, ""),
    confirmstatus: jspb.Message.getFieldWithDefault(msg, 6, 0),
    attendstatus: jspb.Message.getFieldWithDefault(msg, 7, 0),
    devicetype: jspb.Message.getFieldWithDefault(msg, 8, 0),
    rolesList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConferenceMemberInfo}
 */
proto.proto.Entity.ConferenceMemberInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConferenceMemberInfo;
  return proto.proto.Entity.ConferenceMemberInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConferenceMemberInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConferenceMemberInfo}
 */
proto.proto.Entity.ConferenceMemberInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpnamespell(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setConfirmstatus(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAttendstatus(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDevicetype(value);
      break;
    case 9:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRoles(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConferenceMemberInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConferenceMemberInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceMemberInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCorpname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCorpnamespell();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getConfirmstatus();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getAttendstatus();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getDevicetype();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writePackedUint32(
      9,
      f
    );
  }
};


/**
 * optional string corpId = 1;
 * @return {string}
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceMemberInfo} returns this
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string userId = 2;
 * @return {string}
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceMemberInfo} returns this
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string corpName = 3;
 * @return {string}
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.getCorpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceMemberInfo} returns this
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.setCorpname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string nickName = 4;
 * @return {string}
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceMemberInfo} returns this
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string corpNameSpell = 5;
 * @return {string}
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.getCorpnamespell = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceMemberInfo} returns this
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.setCorpnamespell = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 confirmStatus = 6;
 * @return {number}
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.getConfirmstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceMemberInfo} returns this
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.setConfirmstatus = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 attendStatus = 7;
 * @return {number}
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.getAttendstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceMemberInfo} returns this
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.setAttendstatus = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 deviceType = 8;
 * @return {number}
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.getDevicetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceMemberInfo} returns this
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.setDevicetype = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated uint32 roles = 9;
 * @return {!Array<number>}
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.getRolesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.proto.Entity.ConferenceMemberInfo} returns this
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.setRolesList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceMemberInfo} returns this
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.addRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceMemberInfo} returns this
 */
proto.proto.Entity.ConferenceMemberInfo.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ConferenceDetailInfo.repeatedFields_ = [9,10,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConferenceDetailInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConferenceDetailInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceDetailInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    conferenceid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 3, 0),
    hostid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    theme: jspb.Message.getFieldWithDefault(msg, 5, ""),
    begintime: jspb.Message.getFieldWithDefault(msg, 6, ""),
    endtime: jspb.Message.getFieldWithDefault(msg, 7, ""),
    conferencestate: jspb.Message.getFieldWithDefault(msg, 8, 0),
    memberinfolistList: jspb.Message.toObjectList(msg.getMemberinfolistList(),
    proto.proto.Entity.ConferenceMemberInfo.toObject, includeInstance),
    attachmentinfolistList: jspb.Message.toObjectList(msg.getAttachmentinfolistList(),
    proto.proto.Entity.AttachmentInfo.toObject, includeInstance),
    taginfolistList: jspb.Message.toObjectList(msg.getTaginfolistList(),
    proto.proto.Entity.TagInfo.toObject, includeInstance),
    mute: jspb.Message.getFieldWithDefault(msg, 12, 0),
    isspecialist: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConferenceDetailInfo}
 */
proto.proto.Entity.ConferenceDetailInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConferenceDetailInfo;
  return proto.proto.Entity.ConferenceDetailInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConferenceDetailInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConferenceDetailInfo}
 */
proto.proto.Entity.ConferenceDetailInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConferenceid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHostid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTheme(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBegintime(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndtime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setConferencestate(value);
      break;
    case 9:
      var value = new proto.proto.Entity.ConferenceMemberInfo;
      reader.readMessage(value,proto.proto.Entity.ConferenceMemberInfo.deserializeBinaryFromReader);
      msg.addMemberinfolist(value);
      break;
    case 10:
      var value = new proto.proto.Entity.AttachmentInfo;
      reader.readMessage(value,proto.proto.Entity.AttachmentInfo.deserializeBinaryFromReader);
      msg.addAttachmentinfolist(value);
      break;
    case 11:
      var value = new proto.proto.Entity.TagInfo;
      reader.readMessage(value,proto.proto.Entity.TagInfo.deserializeBinaryFromReader);
      msg.addTaginfolist(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMute(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsspecialist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConferenceDetailInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConferenceDetailInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceDetailInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConferenceid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getHostid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTheme();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBegintime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEndtime();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getConferencestate();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getMemberinfolistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.proto.Entity.ConferenceMemberInfo.serializeBinaryToWriter
    );
  }
  f = message.getAttachmentinfolistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.proto.Entity.AttachmentInfo.serializeBinaryToWriter
    );
  }
  f = message.getTaginfolistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.proto.Entity.TagInfo.serializeBinaryToWriter
    );
  }
  f = message.getMute();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getIsspecialist();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional string conferenceId = 1;
 * @return {string}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getConferenceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.setConferenceid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 roomKey = 3;
 * @return {number}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string hostId = 4;
 * @return {string}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getHostid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.setHostid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string theme = 5;
 * @return {string}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getTheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.setTheme = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string beginTime = 6;
 * @return {string}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getBegintime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.setBegintime = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string endTime = 7;
 * @return {string}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getEndtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional uint32 conferenceState = 8;
 * @return {number}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getConferencestate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.setConferencestate = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated ConferenceMemberInfo memberInfoList = 9;
 * @return {!Array<!proto.proto.Entity.ConferenceMemberInfo>}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getMemberinfolistList = function() {
  return /** @type{!Array<!proto.proto.Entity.ConferenceMemberInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.ConferenceMemberInfo, 9));
};


/**
 * @param {!Array<!proto.proto.Entity.ConferenceMemberInfo>} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
*/
proto.proto.Entity.ConferenceDetailInfo.prototype.setMemberinfolistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.proto.Entity.ConferenceMemberInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceMemberInfo}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.addMemberinfolist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.proto.Entity.ConferenceMemberInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.clearMemberinfolistList = function() {
  return this.setMemberinfolistList([]);
};


/**
 * repeated AttachmentInfo attachmentInfoList = 10;
 * @return {!Array<!proto.proto.Entity.AttachmentInfo>}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getAttachmentinfolistList = function() {
  return /** @type{!Array<!proto.proto.Entity.AttachmentInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.AttachmentInfo, 10));
};


/**
 * @param {!Array<!proto.proto.Entity.AttachmentInfo>} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
*/
proto.proto.Entity.ConferenceDetailInfo.prototype.setAttachmentinfolistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.proto.Entity.AttachmentInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.AttachmentInfo}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.addAttachmentinfolist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.proto.Entity.AttachmentInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.clearAttachmentinfolistList = function() {
  return this.setAttachmentinfolistList([]);
};


/**
 * repeated TagInfo tagInfoList = 11;
 * @return {!Array<!proto.proto.Entity.TagInfo>}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getTaginfolistList = function() {
  return /** @type{!Array<!proto.proto.Entity.TagInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.TagInfo, 11));
};


/**
 * @param {!Array<!proto.proto.Entity.TagInfo>} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
*/
proto.proto.Entity.ConferenceDetailInfo.prototype.setTaginfolistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.proto.Entity.TagInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.TagInfo}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.addTaginfolist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.proto.Entity.TagInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.clearTaginfolistList = function() {
  return this.setTaginfolistList([]);
};


/**
 * optional uint32 mute = 12;
 * @return {number}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getMute = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.setMute = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional bool isSpecialist = 13;
 * @return {boolean}
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.getIsspecialist = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ConferenceDetailInfo} returns this
 */
proto.proto.Entity.ConferenceDetailInfo.prototype.setIsspecialist = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.QueryConferenceCondition.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.QueryConferenceCondition.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.QueryConferenceCondition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.QueryConferenceCondition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.QueryConferenceCondition.toObject = function(includeInstance, msg) {
  var f, obj = {
    theme: jspb.Message.getFieldWithDefault(msg, 1, ""),
    begintime: jspb.Message.getFieldWithDefault(msg, 2, ""),
    endtime: jspb.Message.getFieldWithDefault(msg, 3, ""),
    corpidsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    tagsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.QueryConferenceCondition}
 */
proto.proto.Entity.QueryConferenceCondition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.QueryConferenceCondition;
  return proto.proto.Entity.QueryConferenceCondition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.QueryConferenceCondition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.QueryConferenceCondition}
 */
proto.proto.Entity.QueryConferenceCondition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTheme(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBegintime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndtime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addCorpids(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.QueryConferenceCondition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.QueryConferenceCondition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.QueryConferenceCondition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.QueryConferenceCondition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTheme();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBegintime();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEndtime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCorpidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
};


/**
 * optional string theme = 1;
 * @return {string}
 */
proto.proto.Entity.QueryConferenceCondition.prototype.getTheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.QueryConferenceCondition} returns this
 */
proto.proto.Entity.QueryConferenceCondition.prototype.setTheme = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string beginTime = 2;
 * @return {string}
 */
proto.proto.Entity.QueryConferenceCondition.prototype.getBegintime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.QueryConferenceCondition} returns this
 */
proto.proto.Entity.QueryConferenceCondition.prototype.setBegintime = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string endTime = 3;
 * @return {string}
 */
proto.proto.Entity.QueryConferenceCondition.prototype.getEndtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.QueryConferenceCondition} returns this
 */
proto.proto.Entity.QueryConferenceCondition.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string corpIds = 4;
 * @return {!Array<string>}
 */
proto.proto.Entity.QueryConferenceCondition.prototype.getCorpidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.QueryConferenceCondition} returns this
 */
proto.proto.Entity.QueryConferenceCondition.prototype.setCorpidsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.QueryConferenceCondition} returns this
 */
proto.proto.Entity.QueryConferenceCondition.prototype.addCorpids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.QueryConferenceCondition} returns this
 */
proto.proto.Entity.QueryConferenceCondition.prototype.clearCorpidsList = function() {
  return this.setCorpidsList([]);
};


/**
 * repeated string tags = 5;
 * @return {!Array<string>}
 */
proto.proto.Entity.QueryConferenceCondition.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.QueryConferenceCondition} returns this
 */
proto.proto.Entity.QueryConferenceCondition.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.QueryConferenceCondition} returns this
 */
proto.proto.Entity.QueryConferenceCondition.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.QueryConferenceCondition} returns this
 */
proto.proto.Entity.QueryConferenceCondition.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ConferenceMemberRole.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConferenceMemberRole.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConferenceMemberRole.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConferenceMemberRole} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceMemberRole.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rolesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConferenceMemberRole}
 */
proto.proto.Entity.ConferenceMemberRole.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConferenceMemberRole;
  return proto.proto.Entity.ConferenceMemberRole.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConferenceMemberRole} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConferenceMemberRole}
 */
proto.proto.Entity.ConferenceMemberRole.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRoles(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConferenceMemberRole.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConferenceMemberRole.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConferenceMemberRole} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceMemberRole.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writePackedUint32(
      2,
      f
    );
  }
};


/**
 * optional string userId = 1;
 * @return {string}
 */
proto.proto.Entity.ConferenceMemberRole.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceMemberRole} returns this
 */
proto.proto.Entity.ConferenceMemberRole.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated uint32 roles = 2;
 * @return {!Array<number>}
 */
proto.proto.Entity.ConferenceMemberRole.prototype.getRolesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.proto.Entity.ConferenceMemberRole} returns this
 */
proto.proto.Entity.ConferenceMemberRole.prototype.setRolesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceMemberRole} returns this
 */
proto.proto.Entity.ConferenceMemberRole.prototype.addRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceMemberRole} returns this
 */
proto.proto.Entity.ConferenceMemberRole.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ConferenceSummaryInfo.repeatedFields_ = [7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConferenceSummaryInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConferenceSummaryInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceSummaryInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    conferenceid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    theme: jspb.Message.getFieldWithDefault(msg, 2, ""),
    begintime: jspb.Message.getFieldWithDefault(msg, 3, ""),
    endtime: jspb.Message.getFieldWithDefault(msg, 4, ""),
    conferencestate: jspb.Message.getFieldWithDefault(msg, 5, 0),
    confirmstatus: jspb.Message.getFieldWithDefault(msg, 6, 0),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    corpnamesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConferenceSummaryInfo}
 */
proto.proto.Entity.ConferenceSummaryInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConferenceSummaryInfo;
  return proto.proto.Entity.ConferenceSummaryInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConferenceSummaryInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConferenceSummaryInfo}
 */
proto.proto.Entity.ConferenceSummaryInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConferenceid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTheme(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBegintime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndtime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setConferencestate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setConfirmstatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addCorpnames(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConferenceSummaryInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConferenceSummaryInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceSummaryInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConferenceid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTheme();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBegintime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEndtime();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getConferencestate();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getConfirmstatus();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getCorpnamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
};


/**
 * optional string conferenceId = 1;
 * @return {string}
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.getConferenceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceSummaryInfo} returns this
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.setConferenceid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string theme = 2;
 * @return {string}
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.getTheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceSummaryInfo} returns this
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.setTheme = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string beginTime = 3;
 * @return {string}
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.getBegintime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceSummaryInfo} returns this
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.setBegintime = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string endTime = 4;
 * @return {string}
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.getEndtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceSummaryInfo} returns this
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 conferenceState = 5;
 * @return {number}
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.getConferencestate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceSummaryInfo} returns this
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.setConferencestate = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 confirmStatus = 6;
 * @return {number}
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.getConfirmstatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceSummaryInfo} returns this
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.setConfirmstatus = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated string tags = 7;
 * @return {!Array<string>}
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.ConferenceSummaryInfo} returns this
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceSummaryInfo} returns this
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceSummaryInfo} returns this
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * repeated string corpNames = 8;
 * @return {!Array<string>}
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.getCorpnamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.ConferenceSummaryInfo} returns this
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.setCorpnamesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceSummaryInfo} returns this
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.addCorpnames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceSummaryInfo} returns this
 */
proto.proto.Entity.ConferenceSummaryInfo.prototype.clearCorpnamesList = function() {
  return this.setCorpnamesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConferenceCorpInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConferenceCorpInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConferenceCorpInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceCorpInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    corpid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    corpname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    corpnamespell: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConferenceCorpInfo}
 */
proto.proto.Entity.ConferenceCorpInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConferenceCorpInfo;
  return proto.proto.Entity.ConferenceCorpInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConferenceCorpInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConferenceCorpInfo}
 */
proto.proto.Entity.ConferenceCorpInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorpnamespell(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConferenceCorpInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConferenceCorpInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConferenceCorpInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceCorpInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorpid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCorpname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCorpnamespell();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string corpId = 1;
 * @return {string}
 */
proto.proto.Entity.ConferenceCorpInfo.prototype.getCorpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceCorpInfo} returns this
 */
proto.proto.Entity.ConferenceCorpInfo.prototype.setCorpid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string corpName = 2;
 * @return {string}
 */
proto.proto.Entity.ConferenceCorpInfo.prototype.getCorpname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceCorpInfo} returns this
 */
proto.proto.Entity.ConferenceCorpInfo.prototype.setCorpname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string corpNameSpell = 3;
 * @return {string}
 */
proto.proto.Entity.ConferenceCorpInfo.prototype.getCorpnamespell = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceCorpInfo} returns this
 */
proto.proto.Entity.ConferenceCorpInfo.prototype.setCorpnamespell = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ConferenceQueryResultInfo.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConferenceQueryResultInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConferenceQueryResultInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConferenceQueryResultInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceQueryResultInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    summaryinfolistList: jspb.Message.toObjectList(msg.getSummaryinfolistList(),
    proto.proto.Entity.ConferenceSummaryInfo.toObject, includeInstance),
    taginfolistList: jspb.Message.toObjectList(msg.getTaginfolistList(),
    proto.proto.Entity.TagInfo.toObject, includeInstance),
    corpinfolistList: jspb.Message.toObjectList(msg.getCorpinfolistList(),
    proto.proto.Entity.ConferenceCorpInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConferenceQueryResultInfo}
 */
proto.proto.Entity.ConferenceQueryResultInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConferenceQueryResultInfo;
  return proto.proto.Entity.ConferenceQueryResultInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConferenceQueryResultInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConferenceQueryResultInfo}
 */
proto.proto.Entity.ConferenceQueryResultInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.ConferenceSummaryInfo;
      reader.readMessage(value,proto.proto.Entity.ConferenceSummaryInfo.deserializeBinaryFromReader);
      msg.addSummaryinfolist(value);
      break;
    case 2:
      var value = new proto.proto.Entity.TagInfo;
      reader.readMessage(value,proto.proto.Entity.TagInfo.deserializeBinaryFromReader);
      msg.addTaginfolist(value);
      break;
    case 3:
      var value = new proto.proto.Entity.ConferenceCorpInfo;
      reader.readMessage(value,proto.proto.Entity.ConferenceCorpInfo.deserializeBinaryFromReader);
      msg.addCorpinfolist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConferenceQueryResultInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConferenceQueryResultInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConferenceQueryResultInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceQueryResultInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummaryinfolistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.ConferenceSummaryInfo.serializeBinaryToWriter
    );
  }
  f = message.getTaginfolistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.proto.Entity.TagInfo.serializeBinaryToWriter
    );
  }
  f = message.getCorpinfolistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.proto.Entity.ConferenceCorpInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ConferenceSummaryInfo summaryInfoList = 1;
 * @return {!Array<!proto.proto.Entity.ConferenceSummaryInfo>}
 */
proto.proto.Entity.ConferenceQueryResultInfo.prototype.getSummaryinfolistList = function() {
  return /** @type{!Array<!proto.proto.Entity.ConferenceSummaryInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.ConferenceSummaryInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.ConferenceSummaryInfo>} value
 * @return {!proto.proto.Entity.ConferenceQueryResultInfo} returns this
*/
proto.proto.Entity.ConferenceQueryResultInfo.prototype.setSummaryinfolistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.ConferenceSummaryInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceSummaryInfo}
 */
proto.proto.Entity.ConferenceQueryResultInfo.prototype.addSummaryinfolist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.ConferenceSummaryInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceQueryResultInfo} returns this
 */
proto.proto.Entity.ConferenceQueryResultInfo.prototype.clearSummaryinfolistList = function() {
  return this.setSummaryinfolistList([]);
};


/**
 * repeated TagInfo tagInfoList = 2;
 * @return {!Array<!proto.proto.Entity.TagInfo>}
 */
proto.proto.Entity.ConferenceQueryResultInfo.prototype.getTaginfolistList = function() {
  return /** @type{!Array<!proto.proto.Entity.TagInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.TagInfo, 2));
};


/**
 * @param {!Array<!proto.proto.Entity.TagInfo>} value
 * @return {!proto.proto.Entity.ConferenceQueryResultInfo} returns this
*/
proto.proto.Entity.ConferenceQueryResultInfo.prototype.setTaginfolistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.proto.Entity.TagInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.TagInfo}
 */
proto.proto.Entity.ConferenceQueryResultInfo.prototype.addTaginfolist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.proto.Entity.TagInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceQueryResultInfo} returns this
 */
proto.proto.Entity.ConferenceQueryResultInfo.prototype.clearTaginfolistList = function() {
  return this.setTaginfolistList([]);
};


/**
 * repeated ConferenceCorpInfo corpInfoList = 3;
 * @return {!Array<!proto.proto.Entity.ConferenceCorpInfo>}
 */
proto.proto.Entity.ConferenceQueryResultInfo.prototype.getCorpinfolistList = function() {
  return /** @type{!Array<!proto.proto.Entity.ConferenceCorpInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.ConferenceCorpInfo, 3));
};


/**
 * @param {!Array<!proto.proto.Entity.ConferenceCorpInfo>} value
 * @return {!proto.proto.Entity.ConferenceQueryResultInfo} returns this
*/
proto.proto.Entity.ConferenceQueryResultInfo.prototype.setCorpinfolistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.proto.Entity.ConferenceCorpInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceCorpInfo}
 */
proto.proto.Entity.ConferenceQueryResultInfo.prototype.addCorpinfolist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.proto.Entity.ConferenceCorpInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceQueryResultInfo} returns this
 */
proto.proto.Entity.ConferenceQueryResultInfo.prototype.clearCorpinfolistList = function() {
  return this.setCorpinfolistList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ConferenceJoinResponseInfo.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConferenceJoinResponseInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConferenceJoinResponseInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConferenceJoinResponseInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceJoinResponseInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    conferenceid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 3, 0),
    rolesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConferenceJoinResponseInfo}
 */
proto.proto.Entity.ConferenceJoinResponseInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConferenceJoinResponseInfo;
  return proto.proto.Entity.ConferenceJoinResponseInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConferenceJoinResponseInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConferenceJoinResponseInfo}
 */
proto.proto.Entity.ConferenceJoinResponseInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConferenceid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 4:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRoles(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConferenceJoinResponseInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConferenceJoinResponseInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConferenceJoinResponseInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceJoinResponseInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConferenceid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writePackedUint32(
      4,
      f
    );
  }
};


/**
 * optional string conferenceId = 1;
 * @return {string}
 */
proto.proto.Entity.ConferenceJoinResponseInfo.prototype.getConferenceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceJoinResponseInfo} returns this
 */
proto.proto.Entity.ConferenceJoinResponseInfo.prototype.setConferenceid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.proto.Entity.ConferenceJoinResponseInfo.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceJoinResponseInfo} returns this
 */
proto.proto.Entity.ConferenceJoinResponseInfo.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 roomKey = 3;
 * @return {number}
 */
proto.proto.Entity.ConferenceJoinResponseInfo.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceJoinResponseInfo} returns this
 */
proto.proto.Entity.ConferenceJoinResponseInfo.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated uint32 roles = 4;
 * @return {!Array<number>}
 */
proto.proto.Entity.ConferenceJoinResponseInfo.prototype.getRolesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.proto.Entity.ConferenceJoinResponseInfo} returns this
 */
proto.proto.Entity.ConferenceJoinResponseInfo.prototype.setRolesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceJoinResponseInfo} returns this
 */
proto.proto.Entity.ConferenceJoinResponseInfo.prototype.addRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceJoinResponseInfo} returns this
 */
proto.proto.Entity.ConferenceJoinResponseInfo.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConferenceRoleRequestNty.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConferenceRoleRequestNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConferenceRoleRequestNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceRoleRequestNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    conferenceid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    requestuserid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    role: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConferenceRoleRequestNty}
 */
proto.proto.Entity.ConferenceRoleRequestNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConferenceRoleRequestNty;
  return proto.proto.Entity.ConferenceRoleRequestNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConferenceRoleRequestNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConferenceRoleRequestNty}
 */
proto.proto.Entity.ConferenceRoleRequestNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConferenceid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestuserid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConferenceRoleRequestNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConferenceRoleRequestNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConferenceRoleRequestNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceRoleRequestNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getConferenceid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestuserid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRole();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional uint32 requestId = 1;
 * @return {number}
 */
proto.proto.Entity.ConferenceRoleRequestNty.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceRoleRequestNty} returns this
 */
proto.proto.Entity.ConferenceRoleRequestNty.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string conferenceId = 2;
 * @return {string}
 */
proto.proto.Entity.ConferenceRoleRequestNty.prototype.getConferenceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceRoleRequestNty} returns this
 */
proto.proto.Entity.ConferenceRoleRequestNty.prototype.setConferenceid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string requestUserId = 3;
 * @return {string}
 */
proto.proto.Entity.ConferenceRoleRequestNty.prototype.getRequestuserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceRoleRequestNty} returns this
 */
proto.proto.Entity.ConferenceRoleRequestNty.prototype.setRequestuserid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 role = 4;
 * @return {number}
 */
proto.proto.Entity.ConferenceRoleRequestNty.prototype.getRole = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceRoleRequestNty} returns this
 */
proto.proto.Entity.ConferenceRoleRequestNty.prototype.setRole = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConferenceRoleRequestReply.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConferenceRoleRequestReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConferenceRoleRequestReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceRoleRequestReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    conferenceid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    requestuserid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    isallow: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConferenceRoleRequestReply}
 */
proto.proto.Entity.ConferenceRoleRequestReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConferenceRoleRequestReply;
  return proto.proto.Entity.ConferenceRoleRequestReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConferenceRoleRequestReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConferenceRoleRequestReply}
 */
proto.proto.Entity.ConferenceRoleRequestReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRequestid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConferenceid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestuserid(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsallow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConferenceRoleRequestReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConferenceRoleRequestReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConferenceRoleRequestReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceRoleRequestReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getConferenceid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequestuserid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsallow();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional uint32 requestId = 1;
 * @return {number}
 */
proto.proto.Entity.ConferenceRoleRequestReply.prototype.getRequestid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceRoleRequestReply} returns this
 */
proto.proto.Entity.ConferenceRoleRequestReply.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string conferenceId = 2;
 * @return {string}
 */
proto.proto.Entity.ConferenceRoleRequestReply.prototype.getConferenceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceRoleRequestReply} returns this
 */
proto.proto.Entity.ConferenceRoleRequestReply.prototype.setConferenceid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string requestUserId = 3;
 * @return {string}
 */
proto.proto.Entity.ConferenceRoleRequestReply.prototype.getRequestuserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceRoleRequestReply} returns this
 */
proto.proto.Entity.ConferenceRoleRequestReply.prototype.setRequestuserid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool isAllow = 4;
 * @return {boolean}
 */
proto.proto.Entity.ConferenceRoleRequestReply.prototype.getIsallow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ConferenceRoleRequestReply} returns this
 */
proto.proto.Entity.ConferenceRoleRequestReply.prototype.setIsallow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConferenceUpdateNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConferenceUpdateNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceUpdateNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    ntyid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ntystate: jspb.Message.getFieldWithDefault(msg, 2, 0),
    conferenceid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    updaterid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    updatetype: jspb.Message.getFieldWithDefault(msg, 5, 0),
    updatetime: jspb.Message.getFieldWithDefault(msg, 6, ""),
    summary: (f = msg.getSummary()) && proto.proto.Entity.ConferenceSummaryInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConferenceUpdateNty}
 */
proto.proto.Entity.ConferenceUpdateNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConferenceUpdateNty;
  return proto.proto.Entity.ConferenceUpdateNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConferenceUpdateNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConferenceUpdateNty}
 */
proto.proto.Entity.ConferenceUpdateNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNtyid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNtystate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setConferenceid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdaterid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUpdatetype(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatetime(value);
      break;
    case 7:
      var value = new proto.proto.Entity.ConferenceSummaryInfo;
      reader.readMessage(value,proto.proto.Entity.ConferenceSummaryInfo.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConferenceUpdateNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConferenceUpdateNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceUpdateNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNtyid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNtystate();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getConferenceid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUpdaterid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUpdatetype();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getUpdatetime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.proto.Entity.ConferenceSummaryInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ntyId = 1;
 * @return {string}
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.getNtyid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceUpdateNty} returns this
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.setNtyid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 ntyState = 2;
 * @return {number}
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.getNtystate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceUpdateNty} returns this
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.setNtystate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string conferenceId = 3;
 * @return {string}
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.getConferenceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceUpdateNty} returns this
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.setConferenceid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string updaterId = 4;
 * @return {string}
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.getUpdaterid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceUpdateNty} returns this
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.setUpdaterid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 updateType = 5;
 * @return {number}
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.getUpdatetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceUpdateNty} returns this
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.setUpdatetype = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string updateTime = 6;
 * @return {string}
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.getUpdatetime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceUpdateNty} returns this
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.setUpdatetime = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional ConferenceSummaryInfo summary = 7;
 * @return {?proto.proto.Entity.ConferenceSummaryInfo}
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.getSummary = function() {
  return /** @type{?proto.proto.Entity.ConferenceSummaryInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.ConferenceSummaryInfo, 7));
};


/**
 * @param {?proto.proto.Entity.ConferenceSummaryInfo|undefined} value
 * @return {!proto.proto.Entity.ConferenceUpdateNty} returns this
*/
proto.proto.Entity.ConferenceUpdateNty.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.ConferenceUpdateNty} returns this
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.ConferenceUpdateNty.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ConferenceUpdateNtyList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConferenceUpdateNtyList.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConferenceUpdateNtyList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConferenceUpdateNtyList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceUpdateNtyList.toObject = function(includeInstance, msg) {
  var f, obj = {
    ntylistList: jspb.Message.toObjectList(msg.getNtylistList(),
    proto.proto.Entity.ConferenceUpdateNty.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConferenceUpdateNtyList}
 */
proto.proto.Entity.ConferenceUpdateNtyList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConferenceUpdateNtyList;
  return proto.proto.Entity.ConferenceUpdateNtyList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConferenceUpdateNtyList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConferenceUpdateNtyList}
 */
proto.proto.Entity.ConferenceUpdateNtyList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.ConferenceUpdateNty;
      reader.readMessage(value,proto.proto.Entity.ConferenceUpdateNty.deserializeBinaryFromReader);
      msg.addNtylist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConferenceUpdateNtyList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConferenceUpdateNtyList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConferenceUpdateNtyList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceUpdateNtyList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNtylistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.ConferenceUpdateNty.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ConferenceUpdateNty ntyList = 1;
 * @return {!Array<!proto.proto.Entity.ConferenceUpdateNty>}
 */
proto.proto.Entity.ConferenceUpdateNtyList.prototype.getNtylistList = function() {
  return /** @type{!Array<!proto.proto.Entity.ConferenceUpdateNty>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.ConferenceUpdateNty, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.ConferenceUpdateNty>} value
 * @return {!proto.proto.Entity.ConferenceUpdateNtyList} returns this
*/
proto.proto.Entity.ConferenceUpdateNtyList.prototype.setNtylistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.ConferenceUpdateNty=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceUpdateNty}
 */
proto.proto.Entity.ConferenceUpdateNtyList.prototype.addNtylist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.ConferenceUpdateNty, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceUpdateNtyList} returns this
 */
proto.proto.Entity.ConferenceUpdateNtyList.prototype.clearNtylistList = function() {
  return this.setNtylistList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.ConferenceModifyParam.repeatedFields_ = [6,7,8,9,10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ConferenceModifyParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ConferenceModifyParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceModifyParam.toObject = function(includeInstance, msg) {
  var f, obj = {
    conferenceid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    theme: jspb.Message.getFieldWithDefault(msg, 2, ""),
    begintime: jspb.Message.getFieldWithDefault(msg, 3, ""),
    endtime: jspb.Message.getFieldWithDefault(msg, 4, ""),
    isaddedattachment: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    addmembersList: jspb.Message.toObjectList(msg.getAddmembersList(),
    proto.proto.Entity.ConferenceMemberInfo.toObject, includeInstance),
    removedmembersList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    updatedattachmentsList: jspb.Message.toObjectList(msg.getUpdatedattachmentsList(),
    proto.proto.Entity.AttachmentInfo.toObject, includeInstance),
    deletedattachmentsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    mute: jspb.Message.getFieldWithDefault(msg, 11, 0),
    isspecialist: jspb.Message.getBooleanFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ConferenceModifyParam}
 */
proto.proto.Entity.ConferenceModifyParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ConferenceModifyParam;
  return proto.proto.Entity.ConferenceModifyParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ConferenceModifyParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ConferenceModifyParam}
 */
proto.proto.Entity.ConferenceModifyParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConferenceid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTheme(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBegintime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndtime(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsaddedattachment(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 7:
      var value = new proto.proto.Entity.ConferenceMemberInfo;
      reader.readMessage(value,proto.proto.Entity.ConferenceMemberInfo.deserializeBinaryFromReader);
      msg.addAddmembers(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addRemovedmembers(value);
      break;
    case 9:
      var value = new proto.proto.Entity.AttachmentInfo;
      reader.readMessage(value,proto.proto.Entity.AttachmentInfo.deserializeBinaryFromReader);
      msg.addUpdatedattachments(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addDeletedattachments(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMute(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsspecialist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ConferenceModifyParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ConferenceModifyParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ConferenceModifyParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConferenceid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTheme();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBegintime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEndtime();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIsaddedattachment();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getAddmembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.proto.Entity.ConferenceMemberInfo.serializeBinaryToWriter
    );
  }
  f = message.getRemovedmembersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getUpdatedattachmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.proto.Entity.AttachmentInfo.serializeBinaryToWriter
    );
  }
  f = message.getDeletedattachmentsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getMute();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getIsspecialist();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * optional string conferenceId = 1;
 * @return {string}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.getConferenceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.setConferenceid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string theme = 2;
 * @return {string}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.getTheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.setTheme = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string beginTime = 3;
 * @return {string}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.getBegintime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.setBegintime = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string endTime = 4;
 * @return {string}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.getEndtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool isAddedAttachment = 5;
 * @return {boolean}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.getIsaddedattachment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.setIsaddedattachment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated string tags = 6;
 * @return {!Array<string>}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * repeated ConferenceMemberInfo addMembers = 7;
 * @return {!Array<!proto.proto.Entity.ConferenceMemberInfo>}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.getAddmembersList = function() {
  return /** @type{!Array<!proto.proto.Entity.ConferenceMemberInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.ConferenceMemberInfo, 7));
};


/**
 * @param {!Array<!proto.proto.Entity.ConferenceMemberInfo>} value
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
*/
proto.proto.Entity.ConferenceModifyParam.prototype.setAddmembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.proto.Entity.ConferenceMemberInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceMemberInfo}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.addAddmembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.proto.Entity.ConferenceMemberInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.clearAddmembersList = function() {
  return this.setAddmembersList([]);
};


/**
 * repeated string removedMembers = 8;
 * @return {!Array<string>}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.getRemovedmembersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.setRemovedmembersList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.addRemovedmembers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.clearRemovedmembersList = function() {
  return this.setRemovedmembersList([]);
};


/**
 * repeated AttachmentInfo updatedAttachments = 9;
 * @return {!Array<!proto.proto.Entity.AttachmentInfo>}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.getUpdatedattachmentsList = function() {
  return /** @type{!Array<!proto.proto.Entity.AttachmentInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.AttachmentInfo, 9));
};


/**
 * @param {!Array<!proto.proto.Entity.AttachmentInfo>} value
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
*/
proto.proto.Entity.ConferenceModifyParam.prototype.setUpdatedattachmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.proto.Entity.AttachmentInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.AttachmentInfo}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.addUpdatedattachments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.proto.Entity.AttachmentInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.clearUpdatedattachmentsList = function() {
  return this.setUpdatedattachmentsList([]);
};


/**
 * repeated string deletedAttachments = 10;
 * @return {!Array<string>}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.getDeletedattachmentsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.setDeletedattachmentsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.addDeletedattachments = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.clearDeletedattachmentsList = function() {
  return this.setDeletedattachmentsList([]);
};


/**
 * optional uint32 mute = 11;
 * @return {number}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.getMute = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.setMute = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional bool isSpecialist = 12;
 * @return {boolean}
 */
proto.proto.Entity.ConferenceModifyParam.prototype.getIsspecialist = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Entity.ConferenceModifyParam} returns this
 */
proto.proto.Entity.ConferenceModifyParam.prototype.setIsspecialist = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.UploadRspInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.UploadRspInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.UploadRspInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.UploadRspInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    uniquekey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    progress: jspb.Message.getFieldWithDefault(msg, 2, ""),
    downloadurl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.UploadRspInfo}
 */
proto.proto.Entity.UploadRspInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.UploadRspInfo;
  return proto.proto.Entity.UploadRspInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.UploadRspInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.UploadRspInfo}
 */
proto.proto.Entity.UploadRspInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUniquekey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProgress(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadurl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.UploadRspInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.UploadRspInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.UploadRspInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.UploadRspInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUniquekey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProgress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDownloadurl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string uniqueKey = 1;
 * @return {string}
 */
proto.proto.Entity.UploadRspInfo.prototype.getUniquekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UploadRspInfo} returns this
 */
proto.proto.Entity.UploadRspInfo.prototype.setUniquekey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string progress = 2;
 * @return {string}
 */
proto.proto.Entity.UploadRspInfo.prototype.getProgress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UploadRspInfo} returns this
 */
proto.proto.Entity.UploadRspInfo.prototype.setProgress = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string downloadUrl = 3;
 * @return {string}
 */
proto.proto.Entity.UploadRspInfo.prototype.getDownloadurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UploadRspInfo} returns this
 */
proto.proto.Entity.UploadRspInfo.prototype.setDownloadurl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.DownloadRspInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.DownloadRspInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.DownloadRspInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.DownloadRspInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    uniquekey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    progress: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.DownloadRspInfo}
 */
proto.proto.Entity.DownloadRspInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.DownloadRspInfo;
  return proto.proto.Entity.DownloadRspInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.DownloadRspInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.DownloadRspInfo}
 */
proto.proto.Entity.DownloadRspInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUniquekey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProgress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.DownloadRspInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.DownloadRspInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.DownloadRspInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.DownloadRspInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUniquekey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProgress();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string uniqueKey = 1;
 * @return {string}
 */
proto.proto.Entity.DownloadRspInfo.prototype.getUniquekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.DownloadRspInfo} returns this
 */
proto.proto.Entity.DownloadRspInfo.prototype.setUniquekey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string progress = 2;
 * @return {string}
 */
proto.proto.Entity.DownloadRspInfo.prototype.getProgress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.DownloadRspInfo} returns this
 */
proto.proto.Entity.DownloadRspInfo.prototype.setProgress = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.UniqueErrorInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.UniqueErrorInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.UniqueErrorInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.UniqueErrorInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    uniquekey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    error: (f = msg.getError()) && proto.proto.Entity.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.UniqueErrorInfo}
 */
proto.proto.Entity.UniqueErrorInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.UniqueErrorInfo;
  return proto.proto.Entity.UniqueErrorInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.UniqueErrorInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.UniqueErrorInfo}
 */
proto.proto.Entity.UniqueErrorInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUniquekey(value);
      break;
    case 2:
      var value = new proto.proto.Entity.Error;
      reader.readMessage(value,proto.proto.Entity.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.UniqueErrorInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.UniqueErrorInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.UniqueErrorInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.UniqueErrorInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUniquekey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.Entity.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uniqueKey = 1;
 * @return {string}
 */
proto.proto.Entity.UniqueErrorInfo.prototype.getUniquekey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.UniqueErrorInfo} returns this
 */
proto.proto.Entity.UniqueErrorInfo.prototype.setUniquekey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Error error = 2;
 * @return {?proto.proto.Entity.Error}
 */
proto.proto.Entity.UniqueErrorInfo.prototype.getError = function() {
  return /** @type{?proto.proto.Entity.Error} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.Error, 2));
};


/**
 * @param {?proto.proto.Entity.Error|undefined} value
 * @return {!proto.proto.Entity.UniqueErrorInfo} returns this
*/
proto.proto.Entity.UniqueErrorInfo.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.UniqueErrorInfo} returns this
 */
proto.proto.Entity.UniqueErrorInfo.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.UniqueErrorInfo.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.PushNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.PushNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.PushNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.PushNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
    ntytype: jspb.Message.getFieldWithDefault(msg, 1, 0),
    content: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.PushNotify}
 */
proto.proto.Entity.PushNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.PushNotify;
  return proto.proto.Entity.PushNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.PushNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.PushNotify}
 */
proto.proto.Entity.PushNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNtytype(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.PushNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.PushNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.PushNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.PushNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNtytype();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 ntyType = 1;
 * @return {number}
 */
proto.proto.Entity.PushNotify.prototype.getNtytype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.PushNotify} returns this
 */
proto.proto.Entity.PushNotify.prototype.setNtytype = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string content = 2;
 * @return {string}
 */
proto.proto.Entity.PushNotify.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.PushNotify} returns this
 */
proto.proto.Entity.PushNotify.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.PushNewMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.PushNewMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.PushNewMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.PushNewMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    msgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    msgmode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    msgtype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    peerid: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.PushNewMessage}
 */
proto.proto.Entity.PushNewMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.PushNewMessage;
  return proto.proto.Entity.PushNewMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.PushNewMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.PushNewMessage}
 */
proto.proto.Entity.PushNewMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMsgmode(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMsgtype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPeerid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.PushNewMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.PushNewMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.PushNewMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.PushNewMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMsgmode();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMsgtype();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPeerid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string msgId = 1;
 * @return {string}
 */
proto.proto.Entity.PushNewMessage.prototype.getMsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.PushNewMessage} returns this
 */
proto.proto.Entity.PushNewMessage.prototype.setMsgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 msgMode = 2;
 * @return {number}
 */
proto.proto.Entity.PushNewMessage.prototype.getMsgmode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.PushNewMessage} returns this
 */
proto.proto.Entity.PushNewMessage.prototype.setMsgmode = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 msgType = 3;
 * @return {number}
 */
proto.proto.Entity.PushNewMessage.prototype.getMsgtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.PushNewMessage} returns this
 */
proto.proto.Entity.PushNewMessage.prototype.setMsgtype = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string peerId = 4;
 * @return {string}
 */
proto.proto.Entity.PushNewMessage.prototype.getPeerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.PushNewMessage} returns this
 */
proto.proto.Entity.PushNewMessage.prototype.setPeerid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.PushSignalingInviteNty.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.PushSignalingInviteNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.PushSignalingInviteNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.PushSignalingInviteNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 2, 0),
    roomsource: jspb.Message.getFieldWithDefault(msg, 3, 0),
    sourceid: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.PushSignalingInviteNty}
 */
proto.proto.Entity.PushSignalingInviteNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.PushSignalingInviteNty;
  return proto.proto.Entity.PushSignalingInviteNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.PushSignalingInviteNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.PushSignalingInviteNty}
 */
proto.proto.Entity.PushSignalingInviteNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRoomsource(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.PushSignalingInviteNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.PushSignalingInviteNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.PushSignalingInviteNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.PushSignalingInviteNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getRoomsource();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSourceid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string roomId = 1;
 * @return {string}
 */
proto.proto.Entity.PushSignalingInviteNty.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.PushSignalingInviteNty} returns this
 */
proto.proto.Entity.PushSignalingInviteNty.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 roomKey = 2;
 * @return {number}
 */
proto.proto.Entity.PushSignalingInviteNty.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.PushSignalingInviteNty} returns this
 */
proto.proto.Entity.PushSignalingInviteNty.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 roomSource = 3;
 * @return {number}
 */
proto.proto.Entity.PushSignalingInviteNty.prototype.getRoomsource = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.PushSignalingInviteNty} returns this
 */
proto.proto.Entity.PushSignalingInviteNty.prototype.setRoomsource = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string sourceId = 4;
 * @return {string}
 */
proto.proto.Entity.PushSignalingInviteNty.prototype.getSourceid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.PushSignalingInviteNty} returns this
 */
proto.proto.Entity.PushSignalingInviteNty.prototype.setSourceid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.ContactMatchResult.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.ContactMatchResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.ContactMatchResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ContactMatchResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    matchkey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    matchtype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.ContactMatchResult}
 */
proto.proto.Entity.ContactMatchResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.ContactMatchResult;
  return proto.proto.Entity.ContactMatchResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.ContactMatchResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.ContactMatchResult}
 */
proto.proto.Entity.ContactMatchResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchkey(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMatchtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.ContactMatchResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.ContactMatchResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.ContactMatchResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.ContactMatchResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchkey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMatchtype();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string matchKey = 1;
 * @return {string}
 */
proto.proto.Entity.ContactMatchResult.prototype.getMatchkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.ContactMatchResult} returns this
 */
proto.proto.Entity.ContactMatchResult.prototype.setMatchkey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 matchType = 2;
 * @return {number}
 */
proto.proto.Entity.ContactMatchResult.prototype.getMatchtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.ContactMatchResult} returns this
 */
proto.proto.Entity.ContactMatchResult.prototype.setMatchtype = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.MatchContactBaseInfoItem.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.MatchContactBaseInfoItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.MatchContactBaseInfoItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.MatchContactBaseInfoItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    matchresult: (f = msg.getMatchresult()) && proto.proto.Entity.ContactMatchResult.toObject(includeInstance, f),
    matchcontact: (f = msg.getMatchcontact()) && proto.proto.Entity.ContactBaseInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.MatchContactBaseInfoItem}
 */
proto.proto.Entity.MatchContactBaseInfoItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.MatchContactBaseInfoItem;
  return proto.proto.Entity.MatchContactBaseInfoItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.MatchContactBaseInfoItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.MatchContactBaseInfoItem}
 */
proto.proto.Entity.MatchContactBaseInfoItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.ContactMatchResult;
      reader.readMessage(value,proto.proto.Entity.ContactMatchResult.deserializeBinaryFromReader);
      msg.setMatchresult(value);
      break;
    case 2:
      var value = new proto.proto.Entity.ContactBaseInfo;
      reader.readMessage(value,proto.proto.Entity.ContactBaseInfo.deserializeBinaryFromReader);
      msg.setMatchcontact(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.MatchContactBaseInfoItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.MatchContactBaseInfoItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.MatchContactBaseInfoItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.MatchContactBaseInfoItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchresult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.Entity.ContactMatchResult.serializeBinaryToWriter
    );
  }
  f = message.getMatchcontact();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.Entity.ContactBaseInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional ContactMatchResult matchResult = 1;
 * @return {?proto.proto.Entity.ContactMatchResult}
 */
proto.proto.Entity.MatchContactBaseInfoItem.prototype.getMatchresult = function() {
  return /** @type{?proto.proto.Entity.ContactMatchResult} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.ContactMatchResult, 1));
};


/**
 * @param {?proto.proto.Entity.ContactMatchResult|undefined} value
 * @return {!proto.proto.Entity.MatchContactBaseInfoItem} returns this
*/
proto.proto.Entity.MatchContactBaseInfoItem.prototype.setMatchresult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.MatchContactBaseInfoItem} returns this
 */
proto.proto.Entity.MatchContactBaseInfoItem.prototype.clearMatchresult = function() {
  return this.setMatchresult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.MatchContactBaseInfoItem.prototype.hasMatchresult = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ContactBaseInfo matchContact = 2;
 * @return {?proto.proto.Entity.ContactBaseInfo}
 */
proto.proto.Entity.MatchContactBaseInfoItem.prototype.getMatchcontact = function() {
  return /** @type{?proto.proto.Entity.ContactBaseInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.Entity.ContactBaseInfo, 2));
};


/**
 * @param {?proto.proto.Entity.ContactBaseInfo|undefined} value
 * @return {!proto.proto.Entity.MatchContactBaseInfoItem} returns this
*/
proto.proto.Entity.MatchContactBaseInfoItem.prototype.setMatchcontact = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Entity.MatchContactBaseInfoItem} returns this
 */
proto.proto.Entity.MatchContactBaseInfoItem.prototype.clearMatchcontact = function() {
  return this.setMatchcontact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Entity.MatchContactBaseInfoItem.prototype.hasMatchcontact = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.MatchContactBaseData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.MatchContactBaseData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.MatchContactBaseData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.MatchContactBaseData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.MatchContactBaseData.toObject = function(includeInstance, msg) {
  var f, obj = {
    matchitemsList: jspb.Message.toObjectList(msg.getMatchitemsList(),
    proto.proto.Entity.MatchContactBaseInfoItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.MatchContactBaseData}
 */
proto.proto.Entity.MatchContactBaseData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.MatchContactBaseData;
  return proto.proto.Entity.MatchContactBaseData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.MatchContactBaseData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.MatchContactBaseData}
 */
proto.proto.Entity.MatchContactBaseData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.MatchContactBaseInfoItem;
      reader.readMessage(value,proto.proto.Entity.MatchContactBaseInfoItem.deserializeBinaryFromReader);
      msg.addMatchitems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.MatchContactBaseData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.MatchContactBaseData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.MatchContactBaseData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.MatchContactBaseData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchitemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.MatchContactBaseInfoItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MatchContactBaseInfoItem matchItems = 1;
 * @return {!Array<!proto.proto.Entity.MatchContactBaseInfoItem>}
 */
proto.proto.Entity.MatchContactBaseData.prototype.getMatchitemsList = function() {
  return /** @type{!Array<!proto.proto.Entity.MatchContactBaseInfoItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.MatchContactBaseInfoItem, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.MatchContactBaseInfoItem>} value
 * @return {!proto.proto.Entity.MatchContactBaseData} returns this
*/
proto.proto.Entity.MatchContactBaseData.prototype.setMatchitemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.MatchContactBaseInfoItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.MatchContactBaseInfoItem}
 */
proto.proto.Entity.MatchContactBaseData.prototype.addMatchitems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.MatchContactBaseInfoItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.MatchContactBaseData} returns this
 */
proto.proto.Entity.MatchContactBaseData.prototype.clearMatchitemsList = function() {
  return this.setMatchitemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.AuthorizationAppInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.AuthorizationAppInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.AuthorizationAppInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AuthorizationAppInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    appname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    logo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accessurl: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.AuthorizationAppInfo}
 */
proto.proto.Entity.AuthorizationAppInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.AuthorizationAppInfo;
  return proto.proto.Entity.AuthorizationAppInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.AuthorizationAppInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.AuthorizationAppInfo}
 */
proto.proto.Entity.AuthorizationAppInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessurl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.AuthorizationAppInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.AuthorizationAppInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.AuthorizationAppInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AuthorizationAppInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getAppname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccessurl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.proto.Entity.AuthorizationAppInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Entity.AuthorizationAppInfo} returns this
 */
proto.proto.Entity.AuthorizationAppInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string appName = 2;
 * @return {string}
 */
proto.proto.Entity.AuthorizationAppInfo.prototype.getAppname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AuthorizationAppInfo} returns this
 */
proto.proto.Entity.AuthorizationAppInfo.prototype.setAppname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string logo = 3;
 * @return {string}
 */
proto.proto.Entity.AuthorizationAppInfo.prototype.getLogo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AuthorizationAppInfo} returns this
 */
proto.proto.Entity.AuthorizationAppInfo.prototype.setLogo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string accessUrl = 4;
 * @return {string}
 */
proto.proto.Entity.AuthorizationAppInfo.prototype.getAccessurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Entity.AuthorizationAppInfo} returns this
 */
proto.proto.Entity.AuthorizationAppInfo.prototype.setAccessurl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.Entity.AuthorizationInfoData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Entity.AuthorizationInfoData.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Entity.AuthorizationInfoData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Entity.AuthorizationInfoData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AuthorizationInfoData.toObject = function(includeInstance, msg) {
  var f, obj = {
    appinfosList: jspb.Message.toObjectList(msg.getAppinfosList(),
    proto.proto.Entity.AuthorizationAppInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Entity.AuthorizationInfoData}
 */
proto.proto.Entity.AuthorizationInfoData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Entity.AuthorizationInfoData;
  return proto.proto.Entity.AuthorizationInfoData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Entity.AuthorizationInfoData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Entity.AuthorizationInfoData}
 */
proto.proto.Entity.AuthorizationInfoData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Entity.AuthorizationAppInfo;
      reader.readMessage(value,proto.proto.Entity.AuthorizationAppInfo.deserializeBinaryFromReader);
      msg.addAppinfos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Entity.AuthorizationInfoData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Entity.AuthorizationInfoData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Entity.AuthorizationInfoData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Entity.AuthorizationInfoData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAppinfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Entity.AuthorizationAppInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AuthorizationAppInfo appInfos = 1;
 * @return {!Array<!proto.proto.Entity.AuthorizationAppInfo>}
 */
proto.proto.Entity.AuthorizationInfoData.prototype.getAppinfosList = function() {
  return /** @type{!Array<!proto.proto.Entity.AuthorizationAppInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Entity.AuthorizationAppInfo, 1));
};


/**
 * @param {!Array<!proto.proto.Entity.AuthorizationAppInfo>} value
 * @return {!proto.proto.Entity.AuthorizationInfoData} returns this
*/
proto.proto.Entity.AuthorizationInfoData.prototype.setAppinfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Entity.AuthorizationAppInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Entity.AuthorizationAppInfo}
 */
proto.proto.Entity.AuthorizationInfoData.prototype.addAppinfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Entity.AuthorizationAppInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.Entity.AuthorizationInfoData} returns this
 */
proto.proto.Entity.AuthorizationInfoData.prototype.clearAppinfosList = function() {
  return this.setAppinfosList([]);
};


goog.object.extend(exports, proto.proto);
